// AddOt.js - FULL version with react-select for all selects
import React, { useEffect, useRef, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";               // prefer named import
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";

function AddOt() {
  // basic refs & state
  const [ldata, setLdata] = useState(null);
  const caseRef = useRef(null);
  const otDocRef = useRef(null);
  const asstDocRef = useRef(null);
  const nurse1Ref = useRef(null);
  const nurse2Ref = useRef(null);
  const anaDocRef = useRef(null);
  const navigate = useNavigate();
  // CKEditor refs
  const diagEditorRef = useRef(null);
  const procEditorRef = useRef(null);
  const courseEditorRef = useRef(null);
  const notesEditorRef = useRef(null);

  const [isSaved, setIsSaved] = useState(false);
  const [otFormatButtons, setOtFormatButtons] = useState([]);
  const [formatBtnsLoading, setFormatBtnsLoading] = useState(false);
   
  // dropdown / search states (we'll use react-select values)
  const [otUhidSuggestions, setOtUhidSuggestions] = useState([]);
  const [uhidErrorShown, setUhidErrorShown] = useState(false);
  const [otDocSearch, setOtDocSearch] = useState("");
  const [showOtDocOptions, setShowOtDocOptions] = useState(false);
  
  const [anaDocSearch, setAnaDocSearch] = useState("");
  const [showAnaDocOptions, setShowAnaDocOptions] = useState(false);
  
  const [nurse1Search, setNurse1Search] = useState("");
  const [showNurse1Options, setShowNurse1Options] = useState(false);
  const [nurse2Search, setNurse2Search] = useState("");
  const [showNurse2Options, setShowNurse2Options] = useState(false);
  
  // logos for PDFs (you said you'll handle PDFs later but keep these for future)
  const [headerLogo, setHeaderLogo] = useState("");
  const [footerImage, setFooterImage] = useState("");
  const [watermarkLogo, setWatermarkLogo] = useState("");


// ===== Medicine States =====
const [otMedicines, setOtMedicines] = useState([]);
const [medicineOptions, setMedicineOptions] = useState([]);
const [showMedicineModal, setShowMedicineModal] = useState(false);
const [medicineLoading, setMedicineLoading] = useState(false);

const getResolvedCaseName = async (caseId) => {
  if (!caseId) return "";
  let name = getCaseNameByIdSafe(caseId);
  if (!name) {
    name = await fetchCaseNameById(caseId);
  }
  return name;
};


const getWardBedResolved = () => {
  const bedObj = formData.beds?.find(
    b => String(b.bed_id) === String(formData.ot_bed)
  );
  return {
    ward: bedObj?.cat_name || "",
    bed: bedObj?.bed_name || ""
  };
};

  // editor toggles and content for case fields (Diagnosis, Procedure, Course, Notes)
  const [editorOpen, setEditorOpen] = useState({
    diagnosis: false,
    procedure: false,
    course_in_hospital: false,
    notes: false,
  });
  const [caseEditors, setCaseEditors] = useState({
    diagnosis: "",
    procedure: "",
    course_in_hospital: "",
    notes: "",
  });

  

  const [formData, setFormData] = useState(() => {
    const now = new Date();
    const isoDateOnly = now.toISOString().split("T")[0]; // YYYY-MM-DD for <input type="date">
    const year = now.getFullYear();
  
    // --- Generate a UNIQUE random OT number like OT1234/2025 ---
    const key = "ot_used_numbers"; // store all used numbers in localStorage
    let usedNumbers = [];
    try {
      usedNumbers = JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      usedNumbers = [];
    }
  
    let randomPart;
    do {
      randomPart = Math.floor(10000 + Math.random() * 90000); // random 4-digit number
    } while (usedNumbers.includes(randomPart));
  
    // store the new number
    usedNumbers.push(randomPart);
    localStorage.setItem(key, JSON.stringify(usedNumbers));
  
    const gen = `OT${randomPart}`; // final formatted OT number
  
    return {
      otitems: [{ sn: 0, ot_item_name: "", ot_item_batch: "", store_min_qty: "" }],
      l1: [], // nurses
      doc: [], // doctors
      item_store: [],
      case: [],
      beds: [],
      ot_id: "",
      ot_ipd_no: "",
      ot_uhid_no: "",
      ot_reg_date: isoDateOnly,
      ot_patient_name: "",
      ot_patient_gender: "Male",
      ot_number: gen, // ✅ Unique random OT number
      ot_bed: "",
      ot_case: "",
      ot_purpose: "",
      ot_anesthesia_doctor: "",
      ot_ref_doctor: "",
      ot_doctor: "",
      ot_asst_doctor: "",
      ot_nurse_name: "",
      ot_asst_nurse: "",
      ot_user: "",
      page_no: 0,
      alertMsg: "",
      alertMsgTyp: "",
      search_key: "",
      isAlert: false,
    };
  });
  
// Put this near your other helpers (where formatDate is defined)
const formatDateTime = (dateStr) => {
  if (!dateStr) return "";

  // Detect if original string had time info before parsing
  const hasTimeInfo = /(\d{1,2}:\d{2})/.test(dateStr);

  // Try parsing
  const d = new Date(dateStr);
  if (isNaN(d)) {
    return dateStr;
  }

  const dd = String(d.getDate()).padStart(2, "0");
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const mon = months[d.getMonth()];
  const yyyy = d.getFullYear();

  if (!hasTimeInfo) {
    // Only show date — no time info found in original string
    return `${dd}-${mon}-${yyyy}`;
  }

  // If actual time was given, show it
  const hrs = d.getHours();
  const mins = String(d.getMinutes()).padStart(2, "0");
  const ampm = hrs >= 12 ? "PM" : "AM";
  const hrs12 = (hrs % 12) || 12;

  return `${dd}-${mon}-${yyyy} ${String(hrs12).padStart(2, "0")}:${mins} ${ampm}`;
};



// add this helper near other helpers
const ensureIsoDateTime = (raw) => {
  if (!raw) return ""; // caller will fallback if needed
  const s = String(raw).trim();
  // if already ISO or contains time info, just normalize
  if (s.includes("T") || s.includes(":")) {
    const d = new Date(s);
    if (!isNaN(d)) return d.toISOString();
    return s;
  }
  // if date-only like 'YYYY-MM-DD' or 'dd/mm/yyyy', convert to ISO at midnight local
  const parsedIso = normalizeToIsoDate(s); // returns yyyy-mm-dd or ""
  if (parsedIso) {
    // create date at start of day local and convert to ISO
    const dt = new Date(parsedIso + "T00:00:00");
    if (!isNaN(dt)) return dt.toISOString();
  }
  // last resort
  const fallback = new Date(s);
  return isNaN(fallback) ? "" : fallback.toISOString();
};


// ---------- helper utilities (move these above any handler that uses them) ----------
/**
 * Convert image URL to base64 data URL for jsPDF.
 * Keeps the original implementation but placed early so it's in-scope.
 */
const imageUrlToBase64 = async (url) => {
  if (!url) return null;
  // if already a data URI, return as-is
  if (String(url).startsWith("data:")) return url;

  // try using Image + canvas (works if remote server provides proper CORS headers)
  const tryImageToCanvas = () =>
    new Promise((resolve) => {
      try {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL("image/png");
            resolve(dataUrl);
          } catch (e) {
            console.warn("canvas draw error", e);
            resolve(null);
          }
        };
        img.onerror = (e) => {
          console.warn("Image load error", e);
          resolve(null);
        };
        img.src = url;
        // in some browsers, if image is already cached and crossOrigin fails,
        // onload may not fire; we still rely on onerror/onload.
      } catch (err) {
        console.warn("tryImageToCanvas exception", err);
        resolve(null);
      }
    });

  try {
    const fromCanvas = await tryImageToCanvas();
    if (fromCanvas) return fromCanvas;
  } catch (e) {
    console.warn("tryImageToCanvas failed", e);
  }

  // fallback to fetch+blob -> FileReader (will fail if CORS blocks)
  try {
    const resp = await fetch(url, { mode: "cors" });
    if (!resp.ok) return null;
    const blob = await resp.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("imageUrlToBase64 fallback fetch failed:", err);
    return null;
  }
};

const mapCaseMedicinesToOt = (caseMeds = []) => {
  if (!Array.isArray(caseMeds)) return [];

  return caseMeds.map((m) => {
    const opt = medicineOptions.find(o => String(o.value) === String(m.med_id));

    return {
      value: m.med_id,
      label: opt?.label || m.med_name || "Unknown Medicine",
      morning: String(m.morning || ""),
      noon: String(m.noon || ""),
      evening: String(m.evening || ""),
      night: String(m.night || ""),
    };
  });
};


const fetchMedicineList = async () => {
  setMedicineLoading(true);
  try {
    const fd = new FormData();
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.getMedListUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (res.data?.status && Array.isArray(res.data.records)) {
      const meds = res.data.records.map(m => ({
        value: m.med_id,
        label: m.med_name,
      }));
      setMedicineOptions(meds);
    }
  } catch (err) {
    toast.error("Failed to load medicine list");
  } finally {
    setMedicineLoading(false);
  }
};

const fetchOtFormatButtons = async () => {
  setFormatBtnsLoading(true);
  try {
    const fd = new FormData();
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.getOtFormatAllUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (res.data.status && res.data.buttons) {
      setOtFormatButtons(res.data.buttons);
    } else {
      setOtFormatButtons([]);
    }
  } catch (err) {
    console.error('fetchOtFormatButtons error:', err);
    setOtFormatButtons([]);
  } finally {
    setFormatBtnsLoading(false);
  }
};

useEffect(() => {
  fetchMedicineList();
}, []);


useEffect(() => { fetchOtFormatButtons(); }, []);
/**
 * Fetch case name by id fallback helper.
 * (If you already have another definition later, remove the duplicate there.)
 */
const fetchCaseNameById = async (catId) => {
  if (!catId && catId !== 0) return "";
  try {
    // try server fetch
    const fd = new FormData();
    fd.append("cat_id", catId);
    const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatByIdUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (resp && resp.data && resp.data.status && resp.data.cat_dt) {
      const cat = resp.data.cat_dt;
      const caseName = cat.cat_name || cat.name || "";

      // if you maintain a local case list (formData.case), merge/update it there:
      setFormData(prev => {
        const existing = Array.isArray(prev.case) ? [...prev.case] : [];
        const idKey = String(cat.cat_id ?? cat.case_id ?? cat.id ?? "");
        const idx = existing.findIndex(x => String(x.cat_id ?? x.case_id ?? x.id ?? "") === idKey);
        if (idx === -1) existing.push(cat);
        else existing[idx] = { ...existing[idx], ...cat };
        return { ...prev, case: existing };
      });

      return caseName;
    }
  } catch (err) {
    console.warn("fetchCaseNameById error", err);
  }
  return "";
};



  /* ------------------------- Helpers ------------------------- */
  const normalizeToIsoDate = (raw) => {
    if (!raw) return "";
    raw = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(raw)) return raw.replace(/\//g, "-");
    let m;
    if ((m = raw.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/))) {
      return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
    }
    const parsed = new Date(raw);
    if (!isNaN(parsed.getTime())) {
      return parsed.toISOString().split("T")[0];
    }
    return "";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${dd}-${months[d.getMonth()]}-${d.getFullYear()}`;
  };

  const getDoctorNameByIdSafe = (id) => {
    if (!id && id !== 0) return "";
    const doc = (formData.doc || []).find(d => String(d.user_id) === String(id));
    return doc ? doc.fname : "";
  };

  const getBedNameById = (id) => {
    if (!id) return "";
    const bed = (formData.beds || []).find(b => String(b.bed_id) === String(id));
    return bed ? bed.bed_name : "";
  };

  const getCaseNameByIdSafe = (id) => {
    if (!id && id !== 0) return "";
    const cases = Array.isArray(formData.case) ? formData.case : [];
    const found = cases.find(c => String(c.cat_id || c.case_id || c.id || "") === String(id));
    return found ? (found.cat_name || found.name || "") : "";
  };

  /* ------------------------- Fetchers ------------------------- */
  const fetchCaseList = async () => {
    try {
      const fd = new FormData();
      fd.append("cat_type", "case");
      fd.append("page_no", "none");
      fd.append("par_by", (ldata && ldata.user_id) ? String(ldata.user_id) : "1");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data && response.data.status) {
        const records = Array.isArray(response.data.records) ? response.data.records : [];
        setFormData(prev => ({ ...prev, case: records }));
        return records;
      } else {
        setFormData(prev => ({ ...prev, case: [] }));
        return [];
      }
    } catch (err) {
      console.error("fetchCaseList error", err);
      setFormData(prev => ({ ...prev, case: [] }));
      return [];
    }
  };

  const fetchUsersByType = async (type) => {
    try {
      const fd = new FormData();
      fd.append("type", type);
      fd.append("search_key", "");
      fd.append("page_no", 0);
      fd.append("user_cre_by", "1");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd);
      if (response.data && response.data.status) {
        const records = response.data.records || [];
        if (type === "doctor") setFormData(prev => ({ ...prev, doc: records }));
        else if (type === "nurse") setFormData(prev => ({ ...prev, l1: records }));
        return records;
      }
    } catch (err) {
      console.error("fetchUsersByType error", err);
    }
    return [];
  };

  const fetchItemStore = async () => {
    try {
      const fd = new FormData();
      fd.append("user_id", 1);
      const response = await axios.post(AppConst.BASE_URL + AppConst.itemListUrl, fd);
      if (response.data && response.data.status) {
        setFormData(prev => ({ ...prev, item_store: response.data.data || [] }));
      }
    } catch (err) {
      console.error("fetchItemStore error", err);
    }
  };

  const fetchBeds = async () => {
    try {
      const fd = new FormData();
      fd.append("page_no", "none");
      fd.append("bed_user", "1");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd);
      if (response.data && response.data.status) {
        setFormData(prev => ({ ...prev, beds: response.data.records || [] }));
      }
    } catch (err) {
      console.error("fetchBeds error", err);
    }
  };

  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data && res.data.status) {
        setHeaderLogo(res.data.header_logo || "");
        setWatermarkLogo(res.data.logo || "");
        setFooterImage(res.data.footer_logo || "");
      }
    } catch (err) {
      // ignore silently
    }
  };

  /* ------------------------- Lifecycle ------------------------- */
  // ---------- Replace existing mount/loadFromSession with this ----------

useEffect(() => {
  // Runs once: fetch required lists first, then apply any session ot_dt for editing
  const init = async () => {
    try {
      // 1) load ldata (session user info)
      const storedL = sessionStorage.getItem("ldata");
      if (storedL) {
        try { setLdata(JSON.parse(storedL)); }
        catch (e) { console.warn("Failed parse ldata", e); }
      }

      // 2) fetch lists in parallel but await them
      const [
        doctors, nurses, items, beds, cases
      ] = await Promise.all([
        fetchUsersByType("doctor"),   // returns array and also sets formData.doc
        fetchUsersByType("nurse"),    // sets formData.l1
        fetchItemStore(),             // sets formData.item_store
        fetchBeds(),                  // sets formData.beds
        fetchCaseList(),   
        fetchConfigData()             // sets formData.case
      ].map(p => p.catch ? p : p)); // ensure promise array works even if functions return undefined

      // NOTE: fetch* helpers update formData via setFormData internally.
      // But to avoid closure/stale issues we will keep local copies where possible:
      const docsLocal = Array.isArray(doctors) && doctors.length ? doctors : (formData.doc || []);
      const nursesLocal = Array.isArray(nurses) && nurses.length ? nurses : (formData.l1 || []);
      const casesLocal = Array.isArray(cases) && cases.length ? cases : (formData.case || []);
      const bedsLocal = Array.isArray(beds) && beds.length ? beds : (formData.beds || []);
// --- Ensure defaults for a NEW entry (do NOT overwrite when editing) ---
try {
  const hasEditSession = !!sessionStorage.getItem("ot_dt");
  if (!hasEditSession) {
    const now = new Date();
    // date input needs YYYY-MM-DD
    const isoDateOnly = now.toISOString().split('T')[0];
    // keep a readable unique OT number (you can change format)
    const gen = `OT-${now.getFullYear()}${String(now.getMonth() + 1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}-${String(now.getTime()).slice(-6)}`;
    setFormData(prev => ({
      ...prev,
      // only set if not already present (defensive)
      ot_number: prev.ot_number && prev.ot_number.trim() ? prev.ot_number : gen,
      ot_reg_date: prev.ot_reg_date && prev.ot_reg_date.trim() ? prev.ot_reg_date : isoDateOnly,
      // ot_datetime keeps full ISO timestamp (useful for AM/PM formatting)
      ot_datetime: prev.ot_datetime && prev.ot_datetime.trim() ? prev.ot_datetime : now.toISOString(),
    }));
  }
} catch (e) {
  console.warn("OT default generation failed", e);
}

      // 3) load session OT (if present) and map fields using the freshly fetched lists
      const stored = sessionStorage.getItem("ot_dt");
      if (!stored) {
        // no edit session — nothing to prefill — safe to exit
        setIsSaved(false);
        setTimeout(() => {
          // optionally focus first field or similar
        }, 10);
        return;
      }

      let parsed = null;
      try { parsed = JSON.parse(stored); } catch (e) { console.warn("Invalid ot_dt JSON", e); }

      if (!parsed) return;

      // helper to normalize input date for <input type="date">
      const toInputDate = (v) => {
        if (!v && v !== 0) return "";
        try {
          const s = String(v).trim();
          if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
          if (/^\d{4}\/\d{2}\/\d{2}$/.test(s)) return s.replace(/\//g, "-");
          // dd/mm/yyyy or dd-mm-yyyy
          const m = s.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/);
          if (m) return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
          // fallback to Date parse
          const d = new Date(s.replace(" ", "T"));
          if (!isNaN(d.getTime())) return d.toISOString().split("T")[0];
        } catch (err) { console.warn("toInputDate error", err); }
        return "";
      };

      // Build new state merging server keys (support many aliases)
      setFormData(prev => {
        const p = parsed || {};
        // ensure arrays are present (use previously fetched lists if set)
        const merged = {
          ...prev,
          doc: docsLocal.length ? docsLocal : prev.doc,
          l1: nursesLocal.length ? nursesLocal : prev.l1,
          case: casesLocal.length ? casesLocal : prev.case,
          beds: bedsLocal.length ? bedsLocal : prev.beds,
          ot_id: p.ot_id ?? p.id ?? prev.ot_id,
          ot_ipd_no: p.ot_ipd_no ?? p.ipd_no ?? p.lab_reg_id ?? prev.ot_ipd_no,
          ot_uhid_no: p.ot_uhid_no ?? p.ipd_uhid ?? p.lab_reg_uhid ?? prev.ot_uhid_no,
          ot_patient_name: p.ot_patient_name ?? p.lab_reg_name ?? p.ipd_patient_name ?? prev.ot_patient_name,
          ot_patient_gender: p.ot_patient_gender ?? p.gender ?? prev.ot_patient_gender,
          ot_patient_age: p.ot_patient_age ?? p.age ?? prev.ot_patient_age,
          ot_patient_mobile: p.ot_patient_mobile ?? p.mobile ?? prev.ot_patient_mobile,
          ot_patient_address: p.ot_patient_address ?? p.address ?? prev.ot_patient_address,
          ot_number: p.ot_number ?? prev.ot_number,
          ot_bed: p.ot_bed ?? p.bed ?? prev.ot_bed,
          ot_case: p.ot_case ?? p.case_id ?? p.cat_id ?? prev.ot_case,
          ot_purpose: p.ot_purpose ?? prev.ot_purpose,
          ot_ref_doctor: p.ot_ref_doctor ?? p.refer_doctor ?? prev.ot_ref_doctor,
          ot_doctor: p.ot_doctor ?? prev.ot_doctor,
          ot_asst_doctor: p.ot_asst_doctor ?? prev.ot_asst_doctor,
          ot_nurse_name: p.ot_nurse_name ?? p.nurse_name ?? prev.ot_nurse_name,
          ot_Pediatric_doctor: p.ot_Pediatric_doctor ?? prev.ot_Pediatric_doctor,
          ot_anesthesia_doctor: p.ot_anesthesia_doctor ?? prev.ot_anesthesia_doctor,
          ot_reg_date: toInputDate(p.ot_reg_date ?? p.reg_date ?? p.admit_date ?? p.lab_reg_date ?? prev.ot_reg_date),
          ot_datetime: p.ot_datetime ?? p.created_at ?? p.ot_reg_date ?? prev.ot_datetime,
          otitems: Array.isArray(p.otitems) ? p.otitems.map((it, i) => ({ sn: i, ...it })) : prev.otitems,
        };
        return merged;
      });

      // 4) set visible search strings (doctor names, nurse names, ana doc, case name) using fresh lists
      try {
        const findById = (arr, id, nameKey = "fname") => {
          if (!id && id !== 0) return null;
          const s = String(id);
          return (Array.isArray(arr) ? arr : []).find(x => String(x.user_id ?? x.cat_id ?? x.id ?? "").trim() === s.trim()) || null;
        };

        // OT doctor text
        let otDocName = parsed.ot_doctor_name || parsed.ot_doctor || "";
        if (parsed.ot_doctor) {
          const d = findById(docsLocal, parsed.ot_doctor);
          otDocName = d ? d.fname || otDocName : otDocName;
        }
        setOtDocSearch(otDocName || "");

        // Anesthesia doctor text
        let anaName = parsed.ot_anesthesia_doctor_name || parsed.ana_name || parsed.ot_anesthesia_doctor || "";
        if (parsed.ot_anesthesia_doctor) {
          const a = findById(docsLocal, parsed.ot_anesthesia_doctor);
          anaName = a ? a.fname : anaName;
        }
        setAnaDocSearch(anaName || "");

        // Nurse names
        const n1 = findById(nursesLocal, parsed.nurse1 ?? parsed.ot_nurse_name ?? parsed.nurse1_id);
        setNurse1Search(n1 ? n1.fname : (parsed.ot_nurse_name || parsed.nurse1_name || ""));

        const n2 = findById(nursesLocal, parsed.nurse2 ?? parsed.ot_asst_nurse ?? parsed.nurse2_id);
        setNurse2Search(n2 ? n2.fname : (parsed.ot_asst_nurse || parsed.nurse2_name || ""));
      } catch (err) {
        //console.warn("Name resolution after loadFromSession failed", err);
      }

      // 5) load case editors content (diagnosis/procedure/etc) if case id present
      (async () => {
        try {
          const caseId = parsed.ot_case ?? parsed.case_id ?? parsed.cat_id;
          if (caseId) {
            await loadCaseDetails(caseId); // this updates caseEditors and caseSearch via your existing code
            // Ensure CKEditor instances get data (small delay so editors mount)
            setTimeout(() => {
              try { if (diagEditorRef.current) diagEditorRef.current.setData(caseEditors.diagnosis || ""); } catch(e) {}
              try { if (procEditorRef.current) procEditorRef.current.setData(caseEditors.procedure || ""); } catch(e) {}
              try { if (courseEditorRef.current) courseEditorRef.current.setData(caseEditors.course_in_hospital || ""); } catch(e) {}
              try { if (notesEditorRef.current) notesEditorRef.current.setData(caseEditors.notes || ""); } catch(e) {}
            }, 120);
          } else {
            // if parsed contains direct diagnosis/procedure, set editors
            setCaseEditors({
              diagnosis: parsed.diagnosis || caseEditors.diagnosis || "",
              procedure: parsed.procedure || caseEditors.procedure || "",
              course_in_hospital: parsed.course_in_hospital || caseEditors.course_in_hospital || "",
              notes: parsed.notes || caseEditors.notes || "",
            });
          }
        } catch (err) {
          //console.warn("Failed to load case details during edit prefill", err);
        }
      })();

      // mark as not-saved (editing existing) so print buttons remain disabled until saving
      setIsSaved(false);

    } catch (err) {
      //console.error("Initialization error in AddOt mount:", err);
    }
  };

  init();

  // cleanup (if you had any listeners elsewhere)
  return () => {
    // nothing special here
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  /* ------------------------- UHID search ------------------------- */
  const searchOtUserNow = async (uhidVal) => {
    const uhid = (uhidVal ?? formData.ot_uhid_no ?? "").trim();
    if (!uhid || uhid.length < 3) {
      setOtUhidSuggestions([]);
      setUhidErrorShown(false);
      return;
    }
    try {
      const fd = new FormData();
      fd.append("lab_reg_uhid", uhid);
      fd.append("search_type", "IPD");
      const response = await axios.post(AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd);
      if (response.data && response.data.status && Array.isArray(response.data.records) && response.data.records.length > 0) {
        const ipdRecords = response.data.records.filter((r) => r.lab_reg_type === "IPD" || !!r.ipd_id || !!r.ipd_uhid);
        setOtUhidSuggestions(ipdRecords.length ? ipdRecords : response.data.records);
        setUhidErrorShown(false);
      } else {
        setOtUhidSuggestions([]);
        if (!uhidErrorShown) { toast.error("UHID does not exist in IPD!"); setUhidErrorShown(true); }
      }
    } catch (err) {
      //console.error("OT UHID Search Error:", err);
      setOtUhidSuggestions([]);
      if (!uhidErrorShown) { toast.error("UHID search error"); setUhidErrorShown(true); }
    }
  };

  const daysBetween = (d1, d2) => {
    const diff = Math.abs(new Date(d2).getTime() - new Date(d1).getTime());
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  };

  const handleSelectOtUser = async (user) => {
    if (!user) return;
    try {
      const ipdUhid = user.ipd_uhid || user.lab_reg_uhid || user.lab_reg_uhid_no || user.uhid || "";
      const ipdId = user.ipd_id || user.lab_reg_id || user.ipd_no || user.id || "";
      const patientName = user.ipd_patient_name || user.lab_reg_name || user.name || "";
      const refDoctor = user.ipd_refer_doctor || user.lab_reg_doctor || user.refer_doctor || "";
      const bed = user.ipd_bed || user.lab_bed || user.bed || "";
      const patientAddress = user.ipd_address || user.lab_reg_address || user.address || "";
      const patientMobile = user.ipd_patient_mobile || user.lab_reg_mobile || user.mobile || "";
      const ipdCase = user.ipd_case || user.lab_reg_case || user.case_id || user.case || user.ipd_case_id || "";
      const regDate = user.ipd_reg_date || user.lab_reg_date || user.admit_date || user.reg_date || user.lab_reg_date_time || "";

      if (regDate) {
        try {
          const days = daysBetween(regDate, new Date());
          if (days > 10) {
            toast.error(`Patient was admitted ${days} days ago — cannot add OT for >10 days ago.`);
            setOtUhidSuggestions([]);
            return;
          }
        } catch (e) { console.warn(e); }
      }

      const patientAge = user.ipd_patient_age || user.ipd_age || user.age || user.lab_reg_age || user.patient_age || "";
      setFormData(prev => ({
        ...prev,
        ot_uhid_no: ipdUhid || prev.ot_uhid_no,
        ot_ipd_no: ipdId || prev.ot_ipd_no,
        ot_patient_name: patientName || prev.ot_patient_name,
        ot_ref_doctor: refDoctor || prev.ot_ref_doctor,
        ot_patient_mobile: patientMobile || prev.ot_patient_mobile,
        ot_patient_address: patientAddress || prev.ot_patient_address,
        ot_bed: bed || "", 
        ot_patient_age: patientAge || prev.ot_patient_age,
        ot_reg_date: regDate ? normalizeToIsoDate(regDate) : prev.ot_reg_date,

        ot_case: ipdCase || prev.ot_case || "",
      }));

      if (ipdCase) {
        let caseIdToUse = ipdCase;
        let localCases = await fetchCaseList();
        if (isNaN(Number(caseIdToUse))) {
          const foundByName = (localCases || []).find(c => (c.cat_name || "").toLowerCase() === String(ipdCase).toLowerCase());
          if (foundByName) caseIdToUse = foundByName.cat_id;
        }
        if (!caseIdToUse && ipdCase && !isNaN(Number(ipdCase))) caseIdToUse = Number(ipdCase);
        if (caseIdToUse) {
          setFormData(prev => ({ ...prev, ot_case: caseIdToUse }));
          await loadCaseDetails(caseIdToUse);
        }
      }

      setOtUhidSuggestions([]);
      setUhidErrorShown(false);
      toast.success("Patient data fetched.");
    } catch (err) {
      //console.error("Error setting patient details:", err);
      toast.error("Failed to set patient data.");
    }
  };

  /* ------------------------- Case details ------------------------- */
  const loadCaseDetails = async (cat_id) => {
    if (!cat_id) return null;
    try {
      const fd = new FormData();
      fd.append("cat_id", cat_id);
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatByIdUrl, fd);
      if (response.data && response.data.status && response.data.cat_dt) {
        const cd = response.data.cat_dt;
        setCaseEditors({
          diagnosis: cd.diagnosis || "",
          procedure: cd.procedure || "",
          course_in_hospital: cd.course_in_hospital || "",
          notes: cd.notes || "",
        });


        // ===== AUTO-COPY MEDICINES FROM CASE → OT =====
if (cd.medicines) {
  try {
    const meds =
      typeof cd.medicines === "string"
        ? JSON.parse(cd.medicines)
        : cd.medicines;

    if (Array.isArray(meds) && meds.length > 0) {
      const mapped = mapCaseMedicinesToOt(meds);
      setOtMedicines(mapped);

      toast.info(`${mapped.length} medicine(s) loaded from case`);
    } else {
      setOtMedicines([]);
    }
  } catch (e) {
    console.error("Case medicine parse error:", e);
    setOtMedicines([]);
  }
} else {
  setOtMedicines([]);
}

        if (cd.cat_name) {
          // keep a case search visible if needed
        }
        setTimeout(() => {
          try { if (diagEditorRef.current) diagEditorRef.current.setData(cd.diagnosis || ""); } catch(e){}
          try { if (procEditorRef.current) procEditorRef.current.setData(cd.procedure || ""); } catch(e){}
          try { if (courseEditorRef.current) courseEditorRef.current.setData(cd.course_in_hospital || ""); } catch(e){}
          try { if (notesEditorRef.current) notesEditorRef.current.setData(cd.notes || ""); } catch(e){}
        }, 50);
        return response.data;
      } else {
        setCaseEditors({ diagnosis: "", procedure: "", course_in_hospital: "", notes: "" });
        return response?.data || null;
      }
    } catch (err) {
      console.error("loadCaseDetails error:", err);
      setCaseEditors({ diagnosis: "", procedure: "", course_in_hospital: "", notes: "" });
      return null;
    }
  };

  useEffect(() => {
    // When UHID changes manually, clear bed unless re-selected by patient fetch
    if (!formData.ot_uhid_no) {
      setFormData(prev => ({ ...prev, ot_bed: "" }));
    }
  }, [formData.ot_uhid_no]);
  

  useEffect(() => {
    if (formData.ot_case && medicineOptions.length > 0) {
      loadCaseDetails(formData.ot_case);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicineOptions]);
  
  const saveCaseEditorsToServer = async () => {
    const catId = formData.ot_case;
    if (!catId) { toast.error("Please select a case before saving."); return; }
    let caseName = getCaseNameByIdSafe(catId);
    if ((!caseName || caseName.trim().length === 0) && String(catId).length > 0) {
      try {
        const fd = new FormData(); fd.append("cat_id", catId);
        const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatByIdUrl, fd, { headers: { "Content-Type": "multipart/form-data" } });
        if (resp && resp.data && resp.data.status && resp.data.cat_dt) {
          caseName = resp.data.cat_dt.cat_name || "";
          setCaseEditors({
            diagnosis: resp.data.cat_dt.diagnosis || caseEditors.diagnosis || "",
            procedure: resp.data.cat_dt.procedure || caseEditors.procedure || "",
            course_in_hospital: resp.data.cat_dt.course_in_hospital || caseEditors.course_in_hospital || "",
            notes: resp.data.cat_dt.notes || caseEditors.notes || "",
          });
        }
      } catch (err) { console.warn(err); }
    }
    if ((!caseName || caseName.trim().length === 0) && caseEditors && caseEditors.diagnosis) {
      // fallback to a typed caseName not ideal; we require a name
    }
    if (!caseName || caseName.trim().length === 0) { toast.error("Case name is empty — cannot save. Please set/choose a valid case."); return; }

    try {
      const fd2 = new FormData();
      fd2.append("cat_id", catId);
      fd2.append("cat_name", caseName);
      fd2.append("cat_type", "case");
      fd2.append("par_by", (ldata && ldata.user_id) ? String(ldata.user_id) : "1");
      fd2.append("diagnosis", caseEditors.diagnosis || "");
      fd2.append("procedure", caseEditors.procedure || "");
      fd2.append("course_in_hospital", caseEditors.course_in_hospital || "");
      fd2.append("notes", caseEditors.notes || "");
      const resp2 = await axios.post(AppConst.BASE_URL + AppConst.addCatUrl, fd2, { headers: { "Content-Type": "multipart/form-data" } });
      if (resp2 && resp2.data && resp2.data.status) {
        toast.success("Case content updated.");
        await fetchCaseList();
        await loadCaseDetails(catId);
        window.dispatchEvent(new CustomEvent("casesUpdated", { detail: { cat_id: catId } }));
      } else {
        const msg = resp2?.data?.success || resp2?.data?.message || "Failed to save case content.";
        toast.error(msg);
      }
    } catch (err) {
      console.error("saveCaseEditorsToServer exception:", err);
      const serverMsg = err?.response?.data?.success || err?.response?.data?.message;
      if (serverMsg) toast.error(serverMsg); else toast.error("Failed to save case content.");
    }
  };

  /* ------------------------- Items & form handlers ------------------------- */
  const handleItemSelect = (index, selectedItem) => {
    setFormData(prev => {
      const updatedItems = [...prev.otitems];
      updatedItems[index] = { ...updatedItems[index], ot_item_name: selectedItem.store_item_name, ot_item_batch: selectedItem.store_batch_no || "", store_min_qty: selectedItem.store_min_qty || "" };
      return { ...prev, otitems: updatedItems };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setIsSaved(false);
  };

  const handleChange1 = (e, index) => {
    if (!e || !e.target) return;
    const { name, value } = e.target;
    const name1 = name.replace(/[0-9]/g, "");
    setFormData(prev => {
      const updatedItems = [...prev.otitems];
      updatedItems[index] = { ...updatedItems[index], [name1]: value };
      return { ...prev, otitems: updatedItems };
    });
  };

  /* ------------------------- Submit ------------------------- */
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const confirm = await Swal.fire({ title: "Save OT entry?", text: "Are you sure you want to save this OT record to the server?", icon: "question", showCancelButton: true, confirmButtonText: "Yes, Save", cancelButtonText: "Cancel", reverseButtons: true });
    if (!confirm.isConfirmed) return;
    Swal.fire({ title: "Saving...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    const fd = new FormData();
    fd.append("ot_id", formData.ot_id);
    fd.append("ot_ipd_no", formData.ot_ipd_no || "");
    fd.append("ot_uhid_no", formData.ot_uhid_no || "");
    fd.append("ot_reg_date", formData.ot_reg_date || "");
    fd.append("ot_patient_name", formData.ot_patient_name || "");
    fd.append("ot_patient_gender", formData.ot_patient_gender || "");
    fd.append("ot_patient_age", formData.ot_patient_age || "");
    fd.append("ot_number", formData.ot_number || "");
    fd.append("ot_case", formData.ot_case || "");
    fd.append("ot_purpose", formData.ot_purpose || "");
    fd.append("ot_anesthesia_doctor", formData.ot_anesthesia_doctor || "");
    fd.append("ot_ref_doctor", formData.ot_ref_doctor || "");
    fd.append("ot_doctor", formData.ot_doctor || "");
    fd.append("ot_asst_doctor", formData.ot_asst_doctor || "");
    fd.append("ot_nurse_name", formData.ot_nurse_name || "");
    fd.append("ot_Pediatric_doctor", formData.ot_Pediatric_doctor || "");
    fd.append("items", JSON.stringify(formData.otitems || []));
    fd.append("ot_user", ldata?.user_id || 1);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addOtUrl, fd, { headers: { "Content-Type": "multipart/form-data" } });
      Swal.close();
      if (response?.data?.status) {
        setFormData(prev => ({ ...prev, isAlert: true, alertMsg: response.data.success, alertMsgTyp: response.data.type }));
        sessionStorage.removeItem("ot_dt");
        toast.success("OT saved successfully");
        setIsSaved(true);
        const after = await Swal.fire({ title: "Saved", html: `<div>${response.data.success || "OT saved successfully."}</div>`, icon: "success"});
      } else {
        const msg = response?.data?.success || response?.data?.message || "Failed to save OT";
        setFormData(prev => ({ ...prev, isAlert: true, alertMsg: msg, alertMsgTyp: response?.data?.type || "danger" }));
        Swal.fire({ title: "Failed", text: msg, icon: "error" });
        toast.error(msg);
      }
    } catch (err) {
      Swal.close();
      console.error("save ot error", err);
      setFormData(prev => ({ ...prev, isAlert: true, alertMsg: "Failed", alertMsgTyp: "danger" }));
      const serverMsg = err?.response?.data?.message || err?.response?.data?.success;
      Swal.fire({ title: "Error", text: serverMsg || "Failed to save OT. Check console.", icon: "error" });
      toast.error("Failed to save OT");
    }
  };

  /* ------------------------- UI Helpers for react-select ------------------------- */
  const doctorOptions = (formData.doc || []).map(d => ({ value: String(d.user_id), label: d.fname }));
  const nurseOptions = (formData.l1 || []).map(n => ({ value: String(n.user_id), label: n.fname }));
  const caseOptions = (formData.case || []).map(c => ({ value: String(c.cat_id), label: c.cat_name }));
  const bedOptions = (formData.beds || []).map(b => ({ value: String(b.bed_id), label: b.bed_name }));

  const selectStyles = { control: (base) => ({ ...base, minHeight: '38px' }), menu: (base) => ({ ...base, zIndex: 1000 }) };

  const getCaseNameById = (id) => {
    const c = caseOptions.find(o => String(o.value) === String(id));
    return c?.label || "-";
  };
  
  const getDoctorNameById = (id) => {
    const d = doctorOptions.find(o => String(o.value) === String(id));
    return d?.label || "-";
  };
  

//from here 
 //from here//
  /* ---------- OT Receipt (uses same layout as earlier) ---------- */
  const generateOtReceiptPdf = async (receiptData) => {
    if (!receiptData) return;
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const headerImageBase64 = await imageUrlToBase64(receiptData.config.headerLogoUrl);
    if (headerImageBase64) doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, 80);
    doc.setFontSize(10); doc.setFont("helvetica", "bold"); doc.rect(40, 90, pageWidth - 80, 25); doc.text("OT Receipt", pageWidth / 2, 107, { align: "center" });
    const leftX = 50; const rightX = pageWidth / 2 + 20; let y = 140;
    const printDetail = (label, value, x, y) => { doc.setFont("helvetica", "bold"); doc.text(`${label} :`, x, y); doc.setFont("helvetica", "normal"); doc.text(`${value || ""}`, x + 95, y); };
    printDetail("UHID No", receiptData.patient.uhid, leftX, y);
    printDetail("OT No", receiptData.patient.regNo, leftX, (y += 15));
    printDetail("Patient Name", receiptData.patient.name, leftX, (y += 15));
    printDetail("Address", receiptData.patient.address, leftX, (y += 15));
    printDetail("Age/Sex", receiptData.patient.ageSex, leftX, (y += 15));
    printDetail("Anesthesia Doctor", receiptData.anesthesia, leftX, (y += 15));
    y = 140;
    printDetail("OT Date", formatDateTime(receiptData.date), rightX, y);
printDetail("DOA", formatDateTime(receiptData.doa), rightX, (y += 15));

    printDetail("Case", receiptData.case, rightX, (y += 15));
    printDetail("Ward / Bed", `${receiptData.ward || ""} / ${receiptData.bed || ""}`, rightX, (y += 15));
    printDetail("OT Doctor", receiptData.doctor, rightX, (y += 15));
    printDetail("Asst. Nurse", receiptData.nurse, rightX, (y += 15));
    let startY = y + 40; const consumables = Array.isArray(receiptData.consumables) ? receiptData.consumables : [];
    if (consumables.length > 0) {
      doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.text("Inventory Consumables", 40, startY);
      autoTable(doc, {
        startY: startY + 10,
        head: [["S.No.", "Name", "Quantity"]],
        body: consumables.map((item, idx) => [idx + 1, item.name || "", item.quantity || ""]),
        theme: "grid",
        margin: { left: 40, right: 40 },
      });
      var finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : startY + 40;
    } else var finalY = startY + 20;
    doc.setFont("helvetica", "normal"); doc.text("(Authorised Signatory)", pageWidth - 60, finalY + 40, { align: "right" });
    const pdfBlobUrl = doc.output("bloburl"); window.open(pdfBlobUrl, "_blank");
  };

  const handlePrintOtReceipt = async () => {
    try {
      const data = formData || {};
      const doctorName = getDoctorNameByIdSafe(data.ot_doctor);
      const ot_anesthesia = getDoctorNameByIdSafe(data.ot_anesthesia_doctor);
      const bed = data.beds ? data.beds.find((b) => String(b.bed_id) === String(data.ot_bed)) : null;
      let caseName = getCaseNameByIdSafe(data.ot_case);
      if ((!caseName || caseName.trim() === "") && data.ot_case) caseName = await fetchCaseNameById(data.ot_case);
      const nurseName = data.ot_nurse_name || "";
      const receiptData = {
        config: { headerLogoUrl: headerLogo },
        patient: { uhid: data.ot_uhid_no || "", regNo: data.ot_number || "", name: data.ot_patient_name || "", address: data.ot_patient_address || "", ageSex: `${(data.ot_patient_age || "").toString().trim()}${data.ot_patient_age ? " / " : ""}${(data.ot_patient_gender || "").toString().trim()}`.trim() },
        date: ensureIsoDateTime(data.ot_datetime || data.ot_reg_date) || new Date().toISOString(),
        doa: ensureIsoDateTime(data.ot_reg_date || data.ot_datetime) || new Date().toISOString(),
        purpose: data.ot_purpose || "",
        ward: bed ? bed.cat_name : "",
        bed: bed ? bed.bed_name : "",
        doctor: doctorName,
        case: caseName,
        nurse: nurseName,
        anesthesia: ot_anesthesia,
        consumables: (data.otitems || []).map(it => ({ name: (it.ot_item_name || "").trim(), quantity: it.store_min_qty || it.ot_item_price || "" })).filter(it => it.name && it.name.length > 0)
      };
      await generateOtReceiptPdf(receiptData);
    } catch (err) { console.error(err); toast.error("Failed to generate OT Receipt"); }
  };

  const generateOtMedicinePdf = async () => {
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;
    let y = 0;
  
    /* ================= HEADER ================= */
    try {
      const headerBase64 = await imageUrlToBase64(headerLogo);
      if (headerBase64) {
        doc.addImage(headerBase64, "PNG", 0, 0, pageWidth, 90);
        y = 110;
      } else {
        y = margin;
      }
    } catch {
      y = margin;
    }
  
    /* ================= TITLE ================= */
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("OT MEDICINE CHART", pageWidth / 2, y, { align: "center" });
    y += 20;
  
    doc.setLineWidth(0.8);
    doc.line(margin, y, pageWidth - margin, y);
    y += 20;
  
    /* ================= PATIENT DETAILS ================= */
    doc.setFontSize(10);
  
    const labelGap = 95;
    const lineGap = 14;
    const leftX = margin;
    const rightX = pageWidth / 2 + 20;
  
    const printRow = (label, value, x, y) => {
      doc.setFont("helvetica", "bold");
      doc.text(label + " :", x, y);
      doc.setFont("helvetica", "normal");
      doc.text(value || "-", x + labelGap, y);
    };
  
    const bedObj = formData.ot_bed
  ? formData.beds?.find(b => String(b.bed_id) === String(formData.ot_bed))
  : null;

    const ward = bedObj?.cat_name || "";
    const bed = bedObj?.bed_name || "";
  
    /* Row 1 */
    printRow("UHID No", formData.ot_uhid_no, leftX, y);
    printRow("OT No", formData.ot_number, rightX, y);
    y += lineGap;
  
    /* Row 2 */
    printRow("Patient Name", formData.ot_patient_name, leftX, y);
    printRow("Address", formData.ot_patient_address, rightX, y);
    y += lineGap;
  
    /* Row 3 */
    printRow(
      "Age / Sex",
      `${formData.ot_patient_age || "-"} / ${formData.ot_patient_gender || "-"}`,
      leftX,
      y
    );
    printRow(
      "Anesthesia Doctor",
      getDoctorNameByIdSafe(formData.ot_anesthesia_doctor),
      rightX,
      y
    );
    y += lineGap;
  
    /* Row 4 (DATE + TIME FIXED ✅) */
    printRow(
      "OT Date",
      formatDateTime(
        ensureIsoDateTime(formData.ot_datetime || formData.ot_reg_date)
      ),
      leftX,
      y
    );
    printRow("DOA", formatDateTime(formData.ot_doa || formData.ot_reg_date), rightX, y);
    y += lineGap;
  
    /* Row 5 */
    printRow(
      "Case",
      getCaseNameByIdSafe(formData.ot_case),
      leftX,
      y
    );
    printRow(
      "Ward / Bed",
      `${ward} / ${bed}`,
      rightX,
      y
    );
    y += lineGap;
  
    /* Row 6 */
    printRow(
      "OT Doctor",
      getDoctorNameByIdSafe(formData.ot_doctor),
      leftX,
      y
    );
    printRow("Asst. Nurse", formData.ot_nurse_name, rightX, y);
    y += 25;
  
    /* ================= MEDICINE TABLE ================= */
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("OT MEDICINES", margin, y);
    y += 10;
  
    /* ---- Minimum 9 rows + double height ---- */
    const MIN_ROWS = 9;
    const rows = [];
  
    for (let i = 0; i < Math.max(MIN_ROWS, otMedicines.length); i++) {
      const m = otMedicines[i];
      rows.push([
        i + 1,
        m?.label || "",
        "",
        "",
        "",
        ""
      ]);
    }
  
    autoTable(doc, {
      startY: y,
      margin: { left: margin, right: margin },
      head: [[
        "Sl No",
        "Medicine Name",
        "Start Time",
        "End Time",
        "Remarks",
        "Sign"
      ]],
      body: rows,
  
      /* 👇 DOUBLE ROW SPACE SETTINGS */
      styles: {
        fontSize: 9,
        cellPadding: 12,          // 🔥 more padding
        minCellHeight: 32,        // 🔥 force tall rows
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.8
      },
      headStyles: {
        fontStyle: "bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 1
      },
      columnStyles: {
        0: { cellWidth: 40, halign: "center" },
        1: { cellWidth: 170 },
        2: { cellWidth: 80, halign: "center" },
        3: { cellWidth: 80, halign: "center" },
        4: { cellWidth: 90 },
        5: { cellWidth: 60 }
      },
      theme: "grid"
    });
  
    /* ================= FOOTER ================= */
    const finalY = doc.lastAutoTable.finalY + 35;
    if (finalY < pageHeight - 20) {
      doc.setFontSize(9);
      doc.text(
        "Generated On : " + new Date().toLocaleString(),
        margin,
        finalY
      );
    }
  
    window.open(doc.output("bloburl"), "_blank");
  };
  
  

  const handlePrintOtMedicine = async () => {
    try {
      await generateOtMedicinePdf();
    } catch (err) {
      console.error(err);
      toast.error("Failed to generate OT Medicine PDF");
    }
  };
  
    


  /* ---------- New: Print Doctor List PDF ---------- */
  const generateDoctorListPdf = async () => {
    const doc = new jsPDF('p','pt','a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    const contentWidth = pageWidth - margin * 2;
    let wardName = "";
    let bedName = "";
    
    if (Array.isArray(formData.beds) && formData.beds.length > 0 && formData.ot_bed) {
      const bedObj = formData.beds.find(b => String(b.bed_id) === String(formData.ot_bed));
      if (bedObj) {
        bedName = bedObj.bed_name || "";
        wardName = bedObj.cat_name || "";
      }
    }
    // --- header image full width (if available) and compute header bottom ---
    let headerBottomY = 10; // fallback top area if no image
    try {
      const headerImageBase64 = await imageUrlToBase64(headerLogo);
      if (headerImageBase64) {
        // choose a reasonable header height, can be adjusted
        const hHeight = 90;
        doc.addImage(headerImageBase64, 'PNG', 0, 1, pageWidth, hHeight);
        headerBottomY = 1 + hHeight; // Y where header ends
      }
    } catch (e) {
      // ignore image errors and keep headerBottomY default
    }
  
    // leave an explicit gap after header so chart never overlaps
    const gapAfterHeader = 16;
    let y = headerBottomY + gapAfterHeader;
  
    // --- Title & patient info (under header) ---
    doc.setFontSize(16);
    doc.setFont('helvetica','bold');
    // place title comfortably under header
    doc.text('Doctor Visit List', pageWidth / 2, y + 4, { align: 'center' });
    


    doc.setFontSize(9.5);
    doc.setFont('helvetica','normal');
  
    const p = formData || {};
  
    // Move y down to start patient info
    y += 26;
  
    // First row: UHID + Name + Reg Date (using contentWidth columns)
    doc.text(`UHID: ${p.ot_uhid_no || ''}`, margin, y);
    doc.text(`Name: ${p.ot_patient_name || ''}`, margin + contentWidth * 0.35, y);
    doc.text(`Reg Date: ${p.ot_reg_date || p.ot_datetime || ''}`, margin + contentWidth * 0.75, y);
  
    y += 14;
    // Second row: Age/Gender + Ward + Bed
    doc.text(`Age/Gender: ${p.ot_patient_age || ''} / ${p.ot_patient_gender || ''}`, margin, y);
    doc.text(`Ward: ${wardName}`, margin + contentWidth * 0.35, y);
doc.text(`Bed: ${bedName}`, margin + contentWidth * 0.75, y);

  
    y += 14;
    // Third row: Surgeon, Referred Doctor, Anesthesia Doctor
    doc.text(
      `OT Surgeon: ${p.ot_doctor_name || getDoctorNameByIdSafe(p.ot_doctor) || ''}`,
      margin,
      y
    );
    doc.text(
      `Referred Doctor: ${p.ipd_refer_doctor_name || getDoctorNameByIdSafe(p.ot_ref_doctor) || ''}`,
      margin + contentWidth * 0.45,
      y
    );
    // 
  
    y += 14;
    // Fourth row: Nurses
    const nurseNames = (p.ot_nurse_name || '') || '';
    doc.text(`Nurse(s): ${nurseNames}`, margin, y);
    doc.text(
        `Anaesthesia Doctor: ${p.ot_anesthesia_doctor_name || getDoctorNameByIdSafe(p.ot_anesthesia_doctor) || ''}`,
        margin + contentWidth * 0.45,
        y
      );
    y += 18; // gap before table
  
    // --- Table header layout like your image ---
    const head = [[
      'DATE',
      'Doctor Name',
      'Signature',
      'Remarks'
     
    ]];
  
    // Prepare rows (you used 18 previously)
    const body = [];
    const ROWS = 18;
    for (let i = 0; i < ROWS; i++) body.push(['', '', '', '', '', '', '', '']);
  
    // Column widths: DATE larger (~28% of content), remaining split between 7 cols
    const dateColW = Math.round(contentWidth * 0.22);
    const remarksColw = Math.round(contentWidth * 0.40);
    const otherColW = Math.round((contentWidth - dateColW) / 4);
  
    // draw table with solid black borders
    autoTable(doc, {
      startY: y,
      head: head,
      body: body,
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 8,
        cellPadding: 6,
        lineColor: [0,0,0],
        lineWidth: 0.8,
        valign: 'middle'
      },
      headStyles: {
        fillColor: [255,255,255],
        textColor: [0,0,0],
        fontStyle: 'bold',
        halign: 'center',
        lineColor: [0,0,0],
        lineWidth: 0.9
      },
      bodyStyles: { fillColor: [255,255,255], textColor: [0,0,0] },
      alternateRowStyles: { fillColor: [255,255,255] },
      columnStyles: {
        0: { cellWidth: dateColW, halign: 'left' },
        1: { cellWidth: otherColW, halign: 'center' },
        2: { cellWidth: otherColW, halign: 'center' },
        3: { cellWidth: remarksColw, halign: 'center' },
        4: { cellWidth: remarksColw, halign: 'center' }
       
      },
      didDrawCell: (data) => {
        const { cell } = data;
        if (!cell) return;
        const x = cell.x;
        const yCell = cell.y;
        const w = cell.width;
        const h = cell.height;
        doc.setDrawColor(0,0,0);
        doc.setLineWidth(0.9);
        doc.rect(x, yCell, w, h);
      },
      theme: 'plain'
    });
  
    // Where table finished
    let finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : (y + 10);
  
    // If signatures wouldn't fit, add a new page and repeat title
    const signatureBlockHeight = 160;
    if (finalY + signatureBlockHeight + margin > pageHeight) {
      doc.addPage();
      // small header/title on new page (no full image repeat)
      doc.setFontSize(12);
      doc.setFont('helvetica','bold');
      doc.text('Doctor Duty List', pageWidth / 2, 48, { align: 'center' });
      finalY = 60;
    }
  
    // comfortable gap between table and signatures
    const sigY = finalY + 80;
    const sigLineLen = 220;
    const leftSigX = margin;
    const rightSigX = pageWidth - margin - sigLineLen;
  
    // Draw signature lines and labels
    doc.setFontSize(10);
    doc.setFont('helvetica','normal');
  
    // doc.text('Doctor Signature', leftSigX, sigY - 10);
    //doc.line(leftSigX, sigY, leftSigX + sigLineLen, sigY);
  
    // doc.text('Nurse Signature', rightSigX, sigY - 10);
    //doc.line(rightSigX, sigY, rightSigX + sigLineLen, sigY);
  
    // Optional centre surgeon signature
    // const midSigX = pageWidth / 2 - sigLineLen / 2;
    // doc.text('OT Surgeon Signature', midSigX, sigY - 10);
    //doc.line(midSigX, sigY, midSigX + sigLineLen, sigY);
  
    // Printed names under lines (if available)
    // const printedY = sigY + 18;
    // doc.setFont('helvetica','bold');
    // if (p.ot_doctor_name || p.ot_doctor) doc.text(String(p.ot_doctor_name || p.ot_doctor), leftSigX, printedY);
    // if (nurseNames) doc.text(String(nurseNames), rightSigX, printedY);
    // if (p.ot_doctor_name || p.ot_doctor) doc.text(String(p.ot_doctor_name || p.ot_doctor), midSigX, printedY);
  
    // Footer generated time
    doc.setFontSize(8);
    doc.setFont('helvetica','normal');
    doc.text(`Generated: ${new Date().toLocaleString()}`, margin, pageHeight - 28);
  
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };

  const generateDoctorNotesPdf = async () => {
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;
    let y = margin;
  
    /* ================= HEADER ================= */
    try {
      const headerBase64 = await imageUrlToBase64(headerLogo);
      if (headerBase64) {
        doc.addImage(headerBase64, "PNG", 0, 0, pageWidth, 90);
        y = 110;
      }
    } catch {
      y = margin;
    }
  
    /* ================= TITLE ================= */
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("DOCTOR NOTES", pageWidth / 2, y, { align: "center" });
    y += 20;
  
    doc.setLineWidth(0.8);
    doc.line(margin, y, pageWidth - margin, y);
    y += 20;
  
    /* ================= PATIENT DETAILS ================= */
    doc.setFontSize(10);
    const labelGap = 95;
    const lineGap = 14;
    const leftX = margin;
    const rightX = pageWidth / 2 + 20;
  
    const printRow = (label, value, x, y) => {
      doc.setFont("helvetica", "bold");
      doc.text(label + " :", x, y);
      doc.setFont("helvetica", "normal");
      doc.text(value || "-", x + labelGap, y);
    };
  
    const bedObj = formData.beds?.find(
      b => String(b.bed_id) === String(formData.ot_bed)
    );
  
    const ward = bedObj?.cat_name || "";
    const bed = bedObj?.bed_name || "";
  
    /* Row 1 */
    printRow("UHID No", formData.ot_uhid_no, leftX, y);
    printRow("OT No", formData.ot_number, rightX, y);
    y += lineGap;
  
    /* Row 2 */
    printRow("Patient Name", formData.ot_patient_name, leftX, y);
    printRow("Address", formData.ot_patient_address, rightX, y);
    y += lineGap;
  
    /* Row 3 */
    printRow(
      "Age / Sex",
      `${formData.ot_patient_age || "-"} / ${formData.ot_patient_gender || "-"}`,
      leftX,
      y
    );
    printRow(
      "Anesthesia Doctor",
      getDoctorNameByIdSafe(formData.ot_anesthesia_doctor),
      rightX,
      y
    );
    y += lineGap;
  
    /* Row 4 */
    printRow(
      "OT Date",
      formatDateTime(
        ensureIsoDateTime(formData.ot_datetime || formData.ot_reg_date)
      ),
      leftX,
      y
    );
    printRow("DOA", formatDateTime(formData.ot_reg_date), rightX, y);
    y += lineGap;
  
    /* Row 5 */
    printRow("Case", getCaseNameByIdSafe(formData.ot_case), leftX, y);
    printRow("Ward / Bed", `${ward} / ${bed}`, rightX, y);
    y += lineGap;
  
    /* Row 6 */
    printRow("OT Doctor", getDoctorNameByIdSafe(formData.ot_doctor), leftX, y);
    printRow("Asst. Nurse", formData.ot_nurse_name, rightX, y);
    y += 25;
  
    /* ================= FULL PAGE BORDER (NOTES AREA) ================= */
    const borderTop = y;
    const borderHeight = pageHeight - borderTop - 50;
  
    doc.setLineWidth(1.2);
    doc.rect(
      margin,
      borderTop,
      pageWidth - margin * 2,
      borderHeight
    );
  
    /* Optional watermark-style hint */
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text(
      "Doctor Notes",
      pageWidth / 2,
      borderTop + borderHeight / 2,
      { align: "center", angle: 45 }
    );
    doc.setTextColor(0);
  
    /* ================= FOOTER ================= */
    doc.setFontSize(9);
    doc.text(
      "Generated On : " + new Date().toLocaleString(),
      margin,
      pageHeight - 20
    );
  
    window.open(doc.output("bloburl"), "_blank");
  };
  const handlePrintDoctorNotes = async () => {
    try {
      await generateDoctorNotesPdf();
    } catch (err) {
      console.error(err);
      toast.error("Failed to generate Doctor Notes PDF");
    }
  };
    

  /* ---------- New: Print Vital Chart PDF (patient-specific) ---------- */
  const generateVitalChartPdf = async () => {
    const doc = new jsPDF('p','pt','a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 30;
    const contentWidth = pageWidth - margin * 2;
    let wardName = "";
    let bedName = "";
    
    if (Array.isArray(formData.beds) && formData.beds.length > 0 && formData.ot_bed) {
      const bedObj = formData.beds.find(b => String(b.bed_id) === String(formData.ot_bed));
      if (bedObj) {
        bedName = bedObj.bed_name || "";
        wardName = bedObj.cat_name || "";
      }
    }
    // --- header image full width (if available) and compute header bottom ---
    let headerBottomY = 10; // fallback top area if no image
    try {
      const headerImageBase64 = await imageUrlToBase64(headerLogo);
      if (headerImageBase64) {
        // choose a reasonable header height, can be adjusted
        const hHeight = 90;
        doc.addImage(headerImageBase64, 'PNG', 0, 1, pageWidth, hHeight);
        headerBottomY = 1 + hHeight; // Y where header ends
      }
    } catch (e) {
      // ignore image errors and keep headerBottomY default
    }
  
    // leave an explicit gap after header so chart never overlaps
    const gapAfterHeader = 16;
    let y = headerBottomY + gapAfterHeader;
  
    // --- Title & patient info (under header) ---
    doc.setFontSize(12);
    doc.setFont('helvetica','bold');
    // place title comfortably under header
    doc.text('Patient Vital Chart', pageWidth / 2, y + 8, { align: 'center' });
  
    doc.setFontSize(9.5);
    doc.setFont('helvetica','normal');
  
    const p = formData || {};
  
    // Move y down to start patient info
    y += 26;
  
    // First row: UHID + Name + Reg Date (using contentWidth columns)
    doc.text(`UHID: ${p.ot_uhid_no || ''}`, margin, y);
    doc.text(`Name: ${p.ot_patient_name || ''}`, margin + contentWidth * 0.35, y);
    doc.text(`Reg Date: ${p.ot_reg_date || p.ot_datetime || ''}`, margin + contentWidth * 0.75, y);
  
    y += 14;
    // Second row: Age/Gender + Ward + Bed
    doc.text(`Age/Gender: ${p.ot_patient_age || ''} / ${p.ot_patient_gender || ''}`, margin, y);
    doc.text(`Ward: ${wardName}`, margin + contentWidth * 0.35, y);
doc.text(`Bed: ${bedName}`, margin + contentWidth * 0.75, y);

  
    y += 14;
    // Third row: Surgeon, Referred Doctor, Anesthesia Doctor
    doc.text(
      `OT Surgeon: ${p.ot_doctor_name || getDoctorNameByIdSafe(p.ot_doctor) || ''}`,
      margin,
      y
    );
    doc.text(
      `Referred Doctor: ${p.ipd_refer_doctor_name || getDoctorNameByIdSafe(p.ot_ref_doctor) || ''}`,
      margin + contentWidth * 0.45,
      y
    );
    // 
  
    y += 14;
    // Fourth row: Nurses
    const nurseNames = (p.ot_nurse_name || '') || '';
    doc.text(`Nurse(s): ${nurseNames}`, margin, y);
    doc.text(
        `Anaesthesia Doctor: ${p.ot_anesthesia_doctor_name || getDoctorNameByIdSafe(p.ot_anesthesia_doctor) || ''}`,
        margin + contentWidth * 0.45,
        y
      );
    y += 18; // gap before table
  
    // --- Table header layout like your image ---
    const head = [[
      'DATE / TIME',
      'BP\nmm-Hg',
      'PULSE\nPm',
      'Spo2\n% \n@room air',
      'WEIGHT\nkg',
      'MP',
      'TEETH &\nGUM',
      'PHYSICAL STATUS\n(ASA)\nI, II, III, IV, V, VI, E',
      'Remarks'
    ]];
  
    // Prepare rows (you used 18 previously)
    const body = [];
    const ROWS = 18;
    for (let i = 0; i < ROWS; i++) body.push(['', '', '', '', '', '', '', '']);
  
    // Column widths: DATE larger (~28% of content), remaining split between 7 cols
    const dateColW = Math.round(contentWidth * 0.22);
    const otherColW = Math.round((contentWidth - dateColW) / 8);
  
    // draw table with solid black borders
    autoTable(doc, {
      startY: y,
      head: head,
      body: body,
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 8,
        cellPadding: 6,
        lineColor: [0,0,0],
        lineWidth: 0.8,
        valign: 'middle'
      },
      headStyles: {
        fillColor: [255,255,255],
        textColor: [0,0,0],
        fontStyle: 'bold',
        halign: 'center',
        lineColor: [0,0,0],
        lineWidth: 0.9
      },
      bodyStyles: { fillColor: [255,255,255], textColor: [0,0,0] },
      alternateRowStyles: { fillColor: [255,255,255] },
      columnStyles: {
        0: { cellWidth: dateColW, halign: 'left' },
        1: { cellWidth: otherColW, halign: 'center' },
        2: { cellWidth: otherColW, halign: 'center' },
        3: { cellWidth: otherColW, halign: 'center' },
        4: { cellWidth: otherColW, halign: 'center' },
        5: { cellWidth: otherColW, halign: 'center' },
        6: { cellWidth: otherColW, halign: 'center' },
        7: { cellWidth: otherColW, halign: 'center' },
        8: { cellWidth: otherColW, halign: 'center' }
      },
      didDrawCell: (data) => {
        const { cell } = data;
        if (!cell) return;
        const x = cell.x;
        const yCell = cell.y;
        const w = cell.width;
        const h = cell.height;
        doc.setDrawColor(0,0,0);
        doc.setLineWidth(0.9);
        doc.rect(x, yCell, w, h);
      },
      theme: 'plain'
    });
  
    // Where table finished
    let finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : (y + 10);
  
    // If signatures wouldn't fit, add a new page and repeat title
    const signatureBlockHeight = 160;
    if (finalY + signatureBlockHeight + margin > pageHeight) {
      doc.addPage();
      // small header/title on new page (no full image repeat)
      doc.setFontSize(12);
      doc.setFont('helvetica','bold');
      doc.text('Patient Vital Chart', pageWidth / 2, 48, { align: 'center' });
      finalY = 60;
    }
  
    // comfortable gap between table and signatures
    const sigY = finalY + 80;
    const sigLineLen = 220;
    const leftSigX = margin;
    const rightSigX = pageWidth - margin - sigLineLen;
  
    // Draw signature lines and labels
    doc.setFontSize(10);
    doc.setFont('helvetica','normal');
  
    doc.text('Doctor Signature', leftSigX, sigY - 10);
    //doc.line(leftSigX, sigY, leftSigX + sigLineLen, sigY);
  
    doc.text('Nurse Signature', rightSigX, sigY - 10);
    //doc.line(rightSigX, sigY, rightSigX + sigLineLen, sigY);
  
    // Optional centre surgeon signature
    const midSigX = pageWidth / 2 - sigLineLen / 2;
    doc.text('OT Surgeon Signature', midSigX, sigY - 10);
    //doc.line(midSigX, sigY, midSigX + sigLineLen, sigY);
  
    // Printed names under lines (if available)
    const printedY = sigY + 18;
    doc.setFont('helvetica','bold');
    // if (p.ot_doctor_name || p.ot_doctor) doc.text(String(p.ot_doctor_name || p.ot_doctor), leftSigX, printedY);
    // if (nurseNames) doc.text(String(nurseNames), rightSigX, printedY);
    // if (p.ot_doctor_name || p.ot_doctor) doc.text(String(p.ot_doctor_name || p.ot_doctor), midSigX, printedY);
  
    // Footer generated time
    doc.setFontSize(8);
    doc.setFont('helvetica','normal');
    doc.text(`Generated: ${new Date().toLocaleString()}`, margin, pageHeight - 28);
  
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };
  
  
/* ------------------------- CONSENT FORM ------------------------- */

const generateConsentFormPdf = async (formData) => {
  const doc = new jsPDF('p', 'pt', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 40;
  const contentWidth = pageWidth - (margin * 2);
  let y = 0; // Yeh variable page par vertical position ko track karega

  // --- 1. Header Image ---
  const headerImageBase64 = await imageUrlToBase64(formData.config.headerLogoUrl);
  if (headerImageBase64) {
      doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 90); // Image ki height adjust kar sakte hain
  }
  y = 110; // Header ke neeche se shuru karo

  // --- 2. Patient Details ---
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  // Left side details
  doc.text(`Patient Name : ${formData.patient.name}`, margin, y);
  doc.text(`Bed : ${formData.patient.bed || 'N/A'}`, margin, y += 15);
  doc.text(`Surgeon Doctor : ${formData.consultant.name}`, margin, y += 15);

  // Right side details (same lines pe)
  y -= 30; // Y ko wapas upar le jao
  const rightX = pageWidth / 2 + 60;
  doc.text(`Age / Gender : ${formData.patient.age} / ${formData.patient.gender}`, rightX, y);
  doc.text(`UHID NO : ${formData.patient.uhid}`, rightX, y += 15);
  y += 30; // Y ko wapas neeche le aao

  // Helper function to print a centered, bold, underlined title
  const printTitle = (title) => {
      y += 25;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text(title, pageWidth / 2, y, { align: 'center' });
      const textWidth = doc.getTextWidth(title);
      doc.setLineWidth(1);
      doc.line((pageWidth - textWidth) / 2, y + 2, (pageWidth + textWidth) / 2, y + 2); // Underline
      y += 20;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
  };
  
  // Helper function for long paragraphs with text wrapping
  const printParagraph = (text) => {
      const lines = doc.splitTextToSize(text, contentWidth);
      doc.text(lines, margin, y);
      y += (lines.length * 12) + 10; // Line height * number of lines + gap
  };

  // Helper function for signature lines
  const printSignatureLine = (label) => {
      const labelWidth = doc.getTextWidth(label);
      doc.text(label, margin, y);
      doc.line(margin + labelWidth + 5, y - 2, margin + labelWidth + 200, y - 2); // Dotted line
      y += 25;
  };
  
  // --- 3. ADMISSION CONSENT FORM Section ---
  printTitle('ADMISSION CONSENT FORM');

  const consentText = `I ${formData.patient.name} Gender/${formData.patient.gender} Age ${formData.patient.age} understanding that my health condition requires inpatient admission. I consent to, and authorize testing, treatment and hospital care at this hospital. All the terms and conditions were explained to me in my known language and I have understood. I hereby promise to pay the hospital charges for all services and goods provided to me.`;
  printParagraph(consentText);
  
  y += 20;
  doc.text('Signature of Patient/Relative ......................................', margin, y);
  y +=25;
  doc.text('Signature of Guardian ......................................', margin, y);
  doc.text('Relation with the Patient ......................................', pageWidth / 2, y);
  y += 25;
  doc.text('Date/Time ......................................', margin, y);
  y += 25;
  doc.text('Witness ......................................', margin, y);
  
  // --- 4. LETTER OF UNDERTAKING Section ---
  printTitle('LETTER OF UNDERTAKING');
  
  const undertakingText = `I have been appraised of the rules and regulations of the hospital and also the charges of give my consent to be treatment request you to admit me/patient for medical treatment. I am remitting the examined and undertake to pay any further advances when due and the wholeexamined by the treatment charges as per hospital bills on presentation by the hospital authorities. RefundDoctors/Consultants/Nurses of of any amount due to me, may be given to me or the person who is authorised by methe hospital. Undergo essential Dr. ${formData.consultant.name} and his specimen signature is also attested by me. If anytests including procedures for refund is made by cheque may be sent to the address mentioned below. diagnosis and take treatment suggested by the doctors.`;
  printParagraph(undertakingText);

  // Check if we need a new page
  if (y > pageHeight - 150) {
      doc.addPage();
      y = margin;
  }
  
  const legalText = `I agree that any medico legal disputes regarding the patient?s treatment and stay in the hospital will be only subjected to the jurisdiction of courts of ..................................................... and no other courts`;
  printParagraph(legalText);

  y += 20;
  doc.text('Name & Signature of Patient\'s relative ..................................', margin, y);
  doc.text('Relationship ..........................', pageWidth / 2 +20, y);
  y += 25;
  doc.text('Name & Signature of Patient ...........................................', margin, y);

  // --- 5. NOTICE Section ---
  printTitle('NOTICE');
  const noticeText = `Information provided at the time of admission regarding the name, age and address, mode, time and place of accident,duration of symptoms etc. will not be changed under any circumstances as per the order of Supreme Court.`;
  printParagraph(noticeText);

  y += 20;
  doc.text('Name & Signature of Patient\'s relative ..................................', margin, y);
  doc.text('Relationship ..........................', pageWidth / 2 + 20, y);
  y += 25;
  doc.text('Name & Signature of Patient ...........................................', margin, y);


  // --- Final Step: Open PDF ---
  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};

const handlePrintConsentForm = () => {
  // yeh tumhara OT JSON data hoga (jaise API se aaya hai)
  const data = formData;

  console.log("Generating Consent Form for Data:", JSON.stringify(data.doc));
  // doctor find karo
  const doctor = data.doc.find(d => d.user_id === data.ot_doctor);
  // nurse find karo
  const nurse = data.l1.find(n => n.user_id === data.ot_nurse_name);

  const pdfData = {
      config: {
          headerLogoUrl: headerLogo,
      },
      patient: {
          name: data.ot_patient_name || "",
          age: data.ot_patient_age || "",   // agar age ka field nahi hai to blank chhod dena
          gender: data.ot_patient_gender || "",
          uhid: data.ot_uhid_no || "",
          bed: getBedNameById(data.ot_bed) || "",

          guardian: data.guardian_name || "" // agar guardian name API me hai
      },
      consultant: {
          name: doctor ? doctor.fname : ""
      },
      nurse: {
          name: nurse ? nurse.fname : ""
      },
      extra: {
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString()
      }
  };

  generateConsentFormPdf(pdfData);
};

/* ------------------------- ANAESTHESIA RECORD ------------------------- */

const generateAnesthesiaRecordPdf =  async (anesthesiaData) => {
  // 1. PDF document setup karna
  const doc = new jsPDF('p', 'pt', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;
  const contentWidth = pageWidth - (margin * 2);
  let y = margin; // 'y' vertical position ko track karega

     const headerImageBase64 = await imageUrlToBase64(headerLogo);
  if (headerImageBase64) {
      doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 90); // Image ki height adjust kar sakte hain
  }
  y = 130;
  // 2. Document ka Title
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('PRE ANAESTHESIA - OPERATIVE RECORD', pageWidth / 2, y, { align: 'center' });
  doc.setLineWidth(1.5);
  doc.line(margin, y + 5, pageWidth - margin, y + 5);
  y += 30; // Title ke baad thoda gap

  // 3. Patient aur Hospital ki Details (2-column layout mein)
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');

  const leftX = margin;
  const rightX = pageWidth / 2 + 20;

  const printDetailRow = (leftLabel, leftValue, rightLabel, rightValue) => {
      doc.text(`${leftLabel} : ${leftValue || 'N/A'}`, leftX, y);
      if (rightLabel) {
          doc.text(`${rightLabel} : ${rightValue || 'N/A'}`, rightX, y);
      }
      y += 18; // Agli line ke liye 'y' ko badhao
  };

  printDetailRow('Name', anesthesiaData.patient.name, 'Age / Gender', `${anesthesiaData.patient.age || 'N/A'} / ${anesthesiaData.patient.gender}`);
  printDetailRow('IPD No', anesthesiaData.patient.ipdNo, 'Date', formatDateTime(anesthesiaData.date));

  printDetailRow('UHID No', anesthesiaData.patient.uhid, 'OT Doctor', anesthesiaData.doctor);
  printDetailRow('Contact', anesthesiaData.patient.contact, 'Ward', anesthesiaData.patient.ward);
  printDetailRow('Proposed Operation', anesthesiaData.proposedOperation, 'Bed', anesthesiaData.patient.bed);
  y += 10;

  // ===================================================================
  // YAHAN SE NAYA DESIGN SHURU HO RAHA HAI (AS PER YOUR IMAGE)
  // ===================================================================

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('1. Vitals', leftX, y);
  y += 15;

  // Vitals Table
  const tableTopY = y;
  const cellHeight = 35;
  const headers = ['BP\nmm-Hg', 'PULSE\nPm', 'Spo2\n%', 'WEIGHT\nkg', 'MP', 'TEETH &\nGUM', 'PHYSICAL\nSTATUS (ASA)'];
  const colWidth = contentWidth / headers.length;

  doc.setLineWidth(1);
  doc.rect(margin, y, contentWidth, cellHeight * 2); // Outer box for headers and values

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  headers.forEach((header, i) => {
      doc.line(margin + (colWidth * (i + 1)), tableTopY, margin + (colWidth * (i + 1)), tableTopY + (cellHeight * 2));
      doc.text(header, margin + (colWidth * i) + (colWidth / 2), tableTopY + 12, { align: 'center' });
  });
  doc.line(margin, tableTopY + cellHeight, pageWidth - margin, tableTopY + cellHeight); // Horizontal line separating header and value

  // Adding "@room air" under Spo2
  doc.setFont('helvetica', 'normal');
  doc.text('@room air', margin + (colWidth * 2) + (colWidth / 2), tableTopY + 30, { align: 'center' });
  
  // Adding ASA Classes under Physical Status
  doc.setFontSize(7);
  doc.text('I, II, III, IV, V, VI, E', margin + (colWidth * 6) + (colWidth / 2), tableTopY + 30, { align: 'center' });


  y += (cellHeight * 2) + 25; // Move 'y' past the table

  // --- Helper for dotted lines ---
  const drawLineWithText = (label, customY, isTwoCol = false) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text(label, leftX, customY);
      const textWidth = doc.getTextWidth(label);
      doc.setLineDashPattern([2, 2], 0); // Dotted line
      if(isTwoCol) {
          doc.line(leftX + textWidth + 5, customY, rightX - 10, customY);
      } else {
          doc.line(leftX + textWidth + 5, customY, pageWidth - margin, customY);
      }
      doc.setLineDashPattern([], 0); // Reset to solid line
  };
  
  // 2. PRE-EXISTING DISEASE
  drawLineWithText('2. PRE-EXISTING DISEASE :- YES/NO      if Yes with medication', y);
  y += 20;
  drawLineWithText('somking/Alcohol/Elicit drug/Herbal Medication :', y);
  y += 25;

  // 3. PREV SURGICAL HISTORY
  drawLineWithText('3. PREV SURGICAL HISTORY:-', y);
  y += 25;

  // 4. INVESTIGATION
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('4. INVESTIGATION:-', leftX, y);
  y += 20;

  const investigationFields = [
      { left: 'Hb% :', right: 'TC :' },
      { left: 'PLT COUNT :', right: 'RBS :' },
      { left: 'S. Creatinine :', right: 'PT INR :' },
      { left: 'TSH :', right: 'CXR :' },
      { left: 'BLOOD GROUP :', right: 'ECG :' },
      { left: 'VIRAL MARKERS :', right: 'Others :' },
      { left: 'OTHERS :', right: null },
  ];
  
  doc.setFont('helvetica', 'normal');
  investigationFields.forEach(field => {
      doc.text(`${field.left} ..........................`, leftX, y);
      if (field.right) {
          doc.text(`${field.right} ..........................`, rightX, y);
      }
      y += 20;
  });
  y += 10;

  // 5. SYSTEMIC EXAMINATION
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('5. SYSTEMIC EXAMINATION :-', leftX, y);
  y += 20;
  
  const systemicFields = [
      { left: 'CHEST :-', right: 'CNS :-' },
      { left: 'CVS :-', right: 'SPINE/ OTHERS :-' },
  ];
  
  doc.setFont('helvetica', 'normal');
  systemicFields.forEach(field => {
      doc.text(`${field.left} ..........................`, leftX, y);
      doc.text(`${field.right} ..........................`, rightX, y);
      y += 20;
  });

  doc.text('Neck movement - Adequate / Restricted', leftX, y);
  y += 20;
  doc.text('Mouth opening - Adequate / Restricted', leftX, y);
  y += 30;

  // 6. Advice
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('6. Advice :-', leftX, y);
  y += 60; // Extra space for advice

  // Signature
doc.setFont('helvetica', 'normal');

// Signature ko thoda niche kar diya (+5 pixels)
doc.text('Signature', pageWidth - margin - 50, y + 7);

// Line jaisi thi waisi hi rahegi
doc.line(pageWidth - margin - 100, y - 5, pageWidth - margin, y - 5);


  // Final Step: Generate and open PDF
  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};

const handlePrintAnesthesiaRecord = async () => {
  try {
    const data = formData || {};
    const bed = data.beds ? data.beds.find((b) => String(b.bed_id) === String(data.ot_bed)) : null;
    const doctorName = getDoctorNameByIdSafe(data.ot_doctor);

    // Ensure we have a local case list to search
    if (!Array.isArray(formData.case) || formData.case.length === 0) {
      // fetchCaseList exists in your file — it updates formData.case
      await fetchCaseList();
    }

    // Resolve case: data.ot_case might be id, name, or fuzzy text
    let resolvedCaseId = "";
    let resolvedCaseName = "";

    const rawCase = data.ot_case;

    const tryLocalResolve = (val) => {
      if (val === null || val === undefined || String(val).trim() === "") return null;
      const cases = Array.isArray(formData.case) ? formData.case : [];
      const v = String(val).trim();

      // try exact id match (numeric or string)
      const byId = cases.find(c => String(c.cat_id ?? c.case_id ?? c.id ?? "").trim() === v);
      if (byId) return { id: String(byId.cat_id ?? byId.case_id ?? byId.id ?? ""), name: byId.cat_name ?? byId.name ?? "" };

      // try exact name match (case-insensitive)
      const byName = cases.find(c => String(c.cat_name ?? c.name ?? "").toLowerCase().trim() === v.toLowerCase());
      if (byName) return { id: String(byName.cat_id ?? byName.case_id ?? byName.id ?? ""), name: byName.cat_name ?? byName.name ?? "" };

      // try fuzzy name (contains)
      const fuzzy = cases.find(c => (String(c.cat_name ?? c.name ?? "").toLowerCase()).includes(v.toLowerCase()));
      if (fuzzy) return { id: String(fuzzy.cat_id ?? fuzzy.case_id ?? fuzzy.id ?? ""), name: fuzzy.cat_name ?? fuzzy.name ?? "" };

      return null;
    };

    // 1) try local
    const local = tryLocalResolve(rawCase);
    if (local) {
      resolvedCaseId = local.id || "";
      resolvedCaseName = local.name || "";
    } else {
      // 2) if looks numeric, try server fetch by id (fetchCaseNameById returns name and updates local list)
      if (rawCase && !isNaN(Number(rawCase))) {
        const fetchedName = await fetchCaseNameById(rawCase);
        if (fetchedName) {
          resolvedCaseId = String(rawCase);
          resolvedCaseName = fetchedName;
        }
      } else if (rawCase && String(rawCase).trim().length > 0) {
        // 3) rawCase is non-numeric string but not found locally -> try fuzzy again after ensuring list is fresh
        // (we already awaited fetchCaseList above)
        const secondTry = tryLocalResolve(rawCase);
        if (secondTry) {
          resolvedCaseId = secondTry.id;
          resolvedCaseName = secondTry.name;
        } else {
          // 4) last resort: use raw text as name
          resolvedCaseName = String(rawCase);
        }
      }
    }

    // Prepare anesthesia data (include both id & name)
    const anaData = {
      patient: {
        name: data.ot_patient_name || "",
        ipdNo: data.ot_ipd_no ? `000${data.ot_ipd_no}` : "",
        uhid: data.ot_uhid_no || "",
        contact: data.ot_patient_mobile || "",
        age: data.ot_patient_age || "",
        gender: data.ot_patient_gender || "",
        ward: bed ? bed.cat_name : "",
        bed: bed ? bed.bed_name : "",
      },
      date: formatDateTime( ensureIsoDateTime(data.ot_reg_date || data.ot_datetime || new Date().toISOString() ) ),

      doctor: doctorName,
      proposedOperation: resolvedCaseName || (data.ot_case || ""),
      //proposedOperationName: resolvedCaseName || (data.ot_case || "")
    };

    await generateAnesthesiaRecordPdf(anaData);
  } catch (err) {
    console.error("handlePrintAnesthesiaRecord:", err);
    toast.error("Failed to generate Anaesthesia Record");
  }
};

const buildOtDataMap = () => {
  const data = formData || {};
  const doctorName = getDoctorNameByIdSafe(data.ot_doctor);
  const asstDocName = getDoctorNameByIdSafe(data.ot_asst_doctor);
  const anaDocName = getDoctorNameByIdSafe(data.ot_anesthesia_doctor);
  const refDocName = getDoctorNameByIdSafe(data.ot_ref_doctor);
  const pedDocName = getDoctorNameByIdSafe(data.ot_Pediatric_doctor);
  const caseName = getCaseNameByIdSafe(data.ot_case);
  const bedObj = (data.beds || []).find(b => String(b.bed_id) === String(data.ot_bed));
  const now = new Date();
 
  return {
    patient_name:      data.ot_patient_name || 'N/A',
    patient_uhid:      data.ot_uhid_no || 'N/A',
    patient_age:       data.ot_patient_age || 'N/A',
    patient_gender:    data.ot_patient_gender || 'N/A',
    patient_mobile:    data.ot_patient_mobile || 'N/A',
    patient_address:   data.ot_patient_address || '',
    patient_ipd_no:    data.ot_ipd_no ? `000${data.ot_ipd_no}` : 'N/A',
    ot_number:         data.ot_number || 'N/A',
    ot_date:           formatDateTime(ensureIsoDateTime(data.ot_datetime || data.ot_reg_date)),
    ot_reg_date:       formatDateTime(data.ot_reg_date || ''),
    ot_case:           caseName || 'N/A',
    ot_doctor:         doctorName || 'N/A',
    ot_asst_doctor:    asstDocName || 'N/A',
    ot_anesthesia_doc: anaDocName || 'N/A',
    ot_ref_doctor:     refDocName || 'N/A',
    ot_nurse:          data.ot_nurse_name || 'N/A',
    ot_pediatric_doc:  pedDocName || 'N/A',
    ot_bed:            bedObj?.bed_name || 'N/A',
    ot_ward:           bedObj?.cat_name || 'N/A',
    ot_purpose:        data.ot_purpose || '',
    consultant_name:   doctorName || 'N/A',
    current_date:      formatDate(now.toISOString()),
    current_time:      now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
  };
};
 
 
// ─────────────────────────────────────────────────────────────────
// STEP 4: Generate custom multi-page PDF from format button
// ─────────────────────────────────────────────────────────────────
 
const generateCustomOtPdf = async (btn) => {
  const pages = btn.pages || [];
  if (pages.length === 0) {
    toast.warning(`No pages configured for "${btn.btn_name}". Please add pages in OT Format.`);
    return;
  }
 
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF(
    btn.btn_orientation === 'landscape' ? 'l' : 'p',
    'pt',
    btn.btn_page_size || 'a4'
  );
 
  const pageWidth  = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const dataMap = buildOtDataMap();
 
  const hexToRgb = (hex) => {
    const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return r ? { r: parseInt(r[1], 16), g: parseInt(r[2], 16), b: parseInt(r[3], 16) } : { r: 0, g: 0, b: 0 };
  };
 
  for (let i = 0; i < pages.length; i++) {
    const pg = pages[i];
 
    // Add new page (except for first)
    if (i > 0) pdf.addPage();
 
    // ── Add background image ──
    if (pg.page_image) {
      const imgUrl = AppConst.BASE_URL + '/' + pg.page_image;
      const imgBase64 = await imageUrlToBase64(imgUrl);
      if (imgBase64) {
        pdf.addImage(imgBase64, 'PNG', 0, 0, pageWidth, pageHeight);
      }
    }
 
    // ── Parse and render variables ──
    let vars = [];
    try { vars = JSON.parse(pg.page_variables || '[]'); } catch { vars = []; }
 
    if (vars.length > 0) {
      vars.forEach(v => {
        const value = dataMap[v.key] || '';
        if (!value) return;
 
        const xPt = (v.x / 100) * pageWidth;
        const yPt = (v.y / 100) * pageHeight;
        const rgb = hexToRgb(v.fontColor || '#000000');
 
        pdf.setFontSize(v.fontSize || 12);
        pdf.setFont('helvetica', v.fontWeight === 'bold' ? 'bold' : 'normal');
        pdf.setTextColor(rgb.r, rgb.g, rgb.b);
        pdf.text(String(value), xPt, yPt);
      });
    } else {
      // No variables → print default patient details on the page
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(0, 0, 0);
 
      let y = 120;
      const leftX = 50;
      const rightX = pageWidth / 2 + 20;
 
      const printLine = (label, value, x, yPos) => {
        pdf.setFont('helvetica', 'bold');
        pdf.text(`${label}:`, x, yPos);
        pdf.setFont('helvetica', 'normal');
        pdf.text(` ${value || ''}`, x + pdf.getTextWidth(`${label}: `), yPos);
      };
 
      printLine('UHID', dataMap.patient_uhid, leftX, y);
      printLine('Patient Name', dataMap.patient_name, leftX, y += 15);
      printLine('Age / Gender', `${dataMap.patient_age} / ${dataMap.patient_gender}`, leftX, y += 15);
      printLine('IPD No', dataMap.patient_ipd_no, leftX, y += 15);
      printLine('Mobile', dataMap.patient_mobile, leftX, y += 15);
 
      y = 120;
      printLine('OT No', dataMap.ot_number, rightX, y);
      printLine('OT Date', dataMap.ot_date, rightX, y += 15);
      printLine('Case', dataMap.ot_case, rightX, y += 15);
      printLine('Ward / Bed', `${dataMap.ot_ward} / ${dataMap.ot_bed}`, rightX, y += 15);
      printLine('OT Doctor', dataMap.ot_doctor, rightX, y += 15);
 
      y += 25;
      printLine('Anesthesia', dataMap.ot_anesthesia_doc, leftX, y);
      printLine('Nurse', dataMap.ot_nurse, rightX, y);
    }
  }
 
  window.open(pdf.output('bloburl'), '_blank');
};
 
 
// ─────────────────────────────────────────────────────────────────
// STEP 5: Smart button click handler
//         If custom format exists for this button name → use it
//         If button name matches a hardcoded function → fallback
// ─────────────────────────────────────────────────────────────────
 
const handleOtFormatBtnClick = async (btn) => {
  const name = (btn.btn_name || '').toLowerCase().trim();
  const hasPages = (btn.pages || []).length > 0;
 
  if (hasPages) {
    // ✅ Custom format exists → generate from template
    await generateCustomOtPdf(btn);
  } else {
    // ❌ No pages → try fallback to hardcoded functions
    if (name.includes('anesthesia') || name.includes('anaesthesia')) {
      handlePrintAnesthesiaRecord();
    } else if (name.includes('consent')) {
      handlePrintConsentForm();
    } else if (name.includes('receipt')) {
      handlePrintOtReceipt();
    } else if (name.includes('vital')) {
      generateVitalChartPdf();
    } else if (name.includes('doctor list')) {
      generateDoctorListPdf();
    } else if (name.includes('medicine')) {
      handlePrintOtMedicine();
    } else if (name.includes('doctor notes')) {
      handlePrintDoctorNotes();
    } else {
      toast.warning(`No pages configured for "${btn.btn_name}". Add pages in OT Format Manager.`);
    }
  }
};
//from here end

function MedicineModal({ show, onClose, medicineOptions, selectedMedicines, onSave, loading }) {
  const [localMedicines, setLocalMedicines] = useState([]);

  useEffect(() => {
    if (show) {
      setLocalMedicines([...selectedMedicines]);
    }
  }, [show, selectedMedicines]);

  const handleMedicineSelect = (selected) => {
    const withDosage = selected.map((s) => {
      const existing = localMedicines.find((m) => m.value === s.value);
      return existing ? existing : {
        ...s,
        morning: '',
        noon: '',
        evening: '',
        night: '',
      };
    });
    setLocalMedicines(withDosage);
  };

  const handleDosageChange = (medId, dosageType, value) => {
    // Only allow numbers
    const numValue = value.replace(/[^0-9]/g, '');
    const updated = localMedicines.map((m) =>
      m.value === medId ? { ...m, [dosageType]: numValue } : m
    );
    setLocalMedicines(updated);
  };

  const handleRemoveMedicine = (medId) => {
    const updated = localMedicines.filter((m) => m.value !== medId);
    setLocalMedicines(updated);
  };

  const handleSaveClick = () => {
    onSave(localMedicines);
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              <i className="ri-medicine-bottle-line me-2"></i>
              Manage Medicines
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold">Search and Select Medicines</label>
              <Select
                isMulti
                options={medicineOptions}
                isLoading={loading}
                onChange={handleMedicineSelect}
                value={localMedicines}
                placeholder="Type to search medicines..."
                className="react-select-container"
                classNamePrefix="react-select"
              />
              <small className="text-muted">Select medicines and enter dosage quantities (1, 2, 3, etc.) for each time</small>
            </div>

            {localMedicines.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '5%' }}>#</th>
                      <th style={{ width: '35%' }}>Medicine Name</th>
                      <th className="text-center" style={{ width: '15%' }}>
                        <i className="ri-sun-line"></i> Morning
                      </th>
                      <th className="text-center" style={{ width: '15%' }}>
                        <i className="ri-sun-fill"></i> Noon
                      </th>
                      <th className="text-center" style={{ width: '15%' }}>
                        <i className="ri-moon-line"></i> Evening
                      </th>
                      <th className="text-center" style={{ width: '15%' }}>
                        <i className="ri-moon-fill"></i> Night
                      </th>
                      <th className="text-center" style={{ width: '7%' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {localMedicines.map((med, index) => (
                      <tr key={med.value}>
                        <td className="text-center align-middle">{index + 1}</td>
                        <td className="align-middle"><strong>{med.label}</strong></td>
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            value={med.morning || ''}
                            onChange={(e) => handleDosageChange(med.value, 'morning', e.target.value)}
                            placeholder="0"
                            maxLength="2"
                            style={{ width: '60px', margin: '0 auto' }}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            value={med.noon || ''}
                            onChange={(e) => handleDosageChange(med.value, 'noon', e.target.value)}
                            placeholder="0"
                            maxLength="2"
                            style={{ width: '60px', margin: '0 auto' }}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            value={med.evening || ''}
                            onChange={(e) => handleDosageChange(med.value, 'evening', e.target.value)}
                            placeholder="0"
                            maxLength="2"
                            style={{ width: '60px', margin: '0 auto' }}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            value={med.night || ''}
                            onChange={(e) => handleDosageChange(med.value, 'night', e.target.value)}
                            placeholder="0"
                            maxLength="2"
                            style={{ width: '60px', margin: '0 auto' }}
                          />
                        </td>
                        <td className="text-center align-middle">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleRemoveMedicine(med.value)}
                            title="Remove medicine"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-info">
                <i className="ri-information-line me-2"></i>
                No medicines selected. Please search and select medicines from the dropdown above.
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onClose}>
              <i className="ri-close-line me-1"></i>Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={handleSaveClick}>
              <i className="ri-save-line me-1"></i>Save Medicines
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

  /* ------------------------- JSX ------------------------- */
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <div className="card-body">
                <h5>Ot Entry</h5>
                <br />
                <div className="live-preview">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* UHID input with suggestions */}
                      <div className="col-md-4">
                        <div className="mb-3 position-relative">
                          <label className="form-label">UHID Number</label>
                          <input id="ot-uhid-field" name="ot_uhid_no" onChange={(e) => { handleChange(e); }} value={formData.ot_uhid_no} className="form-control" placeholder="Enter UHID Number" type="text" onKeyUp={(e) => searchOtUserNow(e.target.value)} autoComplete="off" required />
                          {otUhidSuggestions.length > 0 && (
                            <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
                              {otUhidSuggestions.map((user, idx) => (
                                <li key={idx} className="list-group-item list-group-item-action" onClick={() => handleSelectOtUser(user)} style={{ cursor: "pointer" }}>
                                  {user.lab_reg_uhid || user.ipd_uhid} - {user.lab_reg_name || user.ipd_patient_name}
                                  <span className="badge bg-info ms-2">{user.lab_reg_type || (user.ipd_id ? "IPD" : "")}</span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>

                      {/* Reg date */}
                      <div className="col-md-4">
                        <div>
                          <label className="form-label">Reg. Date</label>
                          <input name="ot_reg_date" onChange={handleChange} value={formData.ot_reg_date} className="form-control" type="date" readOnly style={{ background: "#eeeeee" }} required />
                        </div>
                      </div>

                      {/* Patient name */}
                      <div className="col-md-4">
                        <div>
                          <label className="form-label">Patient Name</label>
                          <input name="ot_patient_name" onChange={handleChange} value={formData.ot_patient_name} className="form-control" placeholder="Enter Patient Name" type="text" readOnly style={{ background: "#eeeeee" }} required />
                        </div>
                      </div>

                      <div className="col-md-12"><br /></div>

                      <div className="col-md-4">
                        <div>
                          <label className="form-label">Gender</label>
                          <input className="form-control" name="ot_patient_gender" onChange={handleChange} value={formData.ot_patient_gender} required readOnly style={{ background: "#eeeeee" }} />
                        </div>
                      </div>

                      <input name="ot_patient_age" onChange={handleChange} value={formData.ot_patient_age || ""} className="form-control" placeholder="Age (e.g. 25, or 25 Y)" type="hidden" readOnly />

                      <div className="col-md-4">
                        <div>
                          <label className="form-label">OT Number</label>
                          <input name="ot_number" value={formData.ot_number} className="form-control" type="text" readOnly />
                        </div>
                      </div>

                      {/* Case selection with react-select */}
                      <div className="col-md-4" ref={caseRef}>
                        <div className="mb-4">
                          <label className="form-label">OT Case</label>
                          <Select
                            styles={selectStyles}
                            isClearable
                            options={caseOptions}
                            value={caseOptions.find(c => String(c.value) === String(formData.ot_case)) || null}
                            onChange={(opt) => {
                              const val = opt ? opt.value : "";
                              setFormData(prev => ({ ...prev, ot_case: val }));
                              if (val) loadCaseDetails(val);
                            }}
                            placeholder="Select case..."
                          />
                          {(!Array.isArray(formData.case) || formData.case.length === 0) && (
                            <small className="text-muted">No case list loaded (check network or initData)</small>
                          )}
                        </div>
                      </div>

                      {/* Refer Doctor (read-only text) */}
                      <div className="col-md-4">
                        <div>
                          <label className="form-label">Refer Doctor</label>
                          <input name="ot_ref_doctor" onChange={handleChange} value={getDoctorNameByIdSafe(formData.ot_ref_doctor) || formData.ot_ref_doctor} className="form-control" type="text" readOnly style={{ background: "#eeeeee" }} required />
                        </div>
                      </div>

                      {/* OT Doctor (react-select) */}
                      <div className="col-md-4" ref={otDocRef}>
                        <label className="form-label">OT Doctor</label>
                        <Select
                          styles={selectStyles}
                          isClearable
                          options={doctorOptions}
                          value={doctorOptions.find(d => String(d.value) === String(formData.ot_doctor)) || null}
                          onChange={(opt) => setFormData(prev => ({ ...prev, ot_doctor: opt ? opt.value : "" }))}
                          placeholder="Select OT doctor..."
                        />
                      </div>

                      {/* Asst Doctor (react-select) */}
                      <div className="col-md-4" ref={asstDocRef}>
                        <label className="form-label">Asst. OT Doctor</label>
                        <Select
                          styles={selectStyles}
                          isClearable
                          options={doctorOptions}
                          value={doctorOptions.find(d => String(d.value) === String(formData.ot_asst_doctor)) || null}
                          onChange={(opt) => setFormData(prev => ({ ...prev, ot_asst_doctor: opt ? opt.value : "" }))}
                          placeholder="Select assistant doctor..."
                        />
                      </div>

                      <div className="col-md-12"><br /></div>

                      {/* Nurse 1 (react-select) */}
                      <div className="col-md-4" ref={nurse1Ref}>
                        <label className="form-label">Asst. Nurse</label>
                        <Select
                          styles={selectStyles}
                          isClearable
                          options={nurseOptions}
                          value={nurseOptions.find(n => String(n.value) === String(formData.nurse1)) || (nurseOptions.find(n => n.label === formData.ot_nurse_name) || null)}
                          onChange={(opt) => {
                            setFormData(prev => ({ ...prev, ot_nurse_name: opt ? opt.label : "", nurse1: opt ? opt.value : "" }));
                          }}
                          placeholder="Select nurse..."
                        />
                      </div>

                      {/* Nurse 2 (react-select) */}
                      <div className="col-md-4" ref={nurse2Ref}>
                        <label className="form-label">Pediatric Doctor</label>
                        <Select
                          styles={selectStyles}
                          isClearable
                          options={doctorOptions}
                          value={doctorOptions.find(d => String(d.value) === String(formData.ot_Pediatric_doctor)) || null}
                          onChange={(opt) => setFormData(prev => ({ ...prev, ot_Pediatric_doctor: opt ? opt.value : "" }))}
                          placeholder="Select Pediatric doctor..."
                        />
                      </div>

                      {/* Anesthesia Doctor (react-select) */}
                      <div className="col-md-4" ref={anaDocRef}>
                        <label className="form-label">Anesthesia Doctor</label>
                        <Select
                          styles={selectStyles}
                          isClearable
                          options={doctorOptions}
                          value={doctorOptions.find(d => String(d.value) === String(formData.ot_anesthesia_doctor)) || null}
                          onChange={(opt) => setFormData(prev => ({ ...prev, ot_anesthesia_doctor: opt ? opt.value : "" }))}
                          placeholder="Select anesthesia doctor..."
                        />
                      </div>

                      <div className="col-md-12"><br /></div>
                      <div className="col-12 mt-4">
  <div className="d-flex justify-content-between align-items-center mb-2">
    <h5 className="mb-0">
      <i className="ri-medicine-bottle-line me-2"></i>
      Prescribed Medicines
    </h5>

    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={() => setShowMedicineModal(true)}
    >
      {otMedicines.length > 0 ? "Edit Medicines" : "Add Medicines"}
    </button>
  </div>

  {otMedicines.length > 0 ? (
    <div className="table-responsive">
      <table className="table table-bordered table-sm">
        <thead className="table-light">
          <tr>
            <th>Sr</th>
            <th>Medicine</th>
            <th className="text-center">Morning</th>
            <th className="text-center">Noon</th>
            <th className="text-center">Evening</th>
            <th className="text-center">Night</th>
          </tr>
        </thead>
        <tbody>
          {otMedicines.map((med, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{med.label}</td>
              <td className="text-center">{med.morning || "-"}</td>
              <td className="text-center">{med.noon || "-"}</td>
              <td className="text-center">{med.evening || "-"}</td>
              <td className="text-center">{med.night || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="alert alert-warning">
      No medicines prescribed
    </div>
  )}
</div>

                      {/* Items table */}
                      <div className="col-lg-12">
                        <div className="row">
                          <div className="col-lg-8">
                            <h5 style={{ color: "#17203b", fontWeight: 600 }}>Items</h5>
                          </div>
                          <div className="col-lg-4" style={{ textAlign: "right" }}>
                            <button type="button" onClick={(e) => { e.preventDefault(); setFormData(prev => ({ ...prev, otitems: [...prev.otitems, { sn: prev.otitems.length, ot_item_name: "", ot_item_batch: "", store_min_qty: "" }] })); }} className="btn btn-primary">Add</button>
                          </div>
                        </div>
                        <br />
                      </div>



{/* ===== Medicine Management ===== */}

                      <div className="col-md-12">
                        <div className="card-body pt-0">
                          <div className="table-responsive table-card mb-1">
                            <table className="table table-nowrap align-middle" id="orderTable">
                              <thead className="text-muted table-light">
                                <tr className="text-uppercase">
                                  <th>S. No.</th>
                                  <th>Name</th>
                                  <th>Batch</th>
                                  <th>QTY</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody className="list form-check-all">
                                {(formData.otitems || []).map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td style={{ position: "relative" }}>
                                      <input name={`ot_item_name${index}`} value={item.ot_item_name} onChange={(e) => handleChange1(e, index)} className="form-control" placeholder="Enter Name" type="text" onFocus={() => { /* optional: show custom dropdown */ }} />
                                    </td>
                                    <td>
                                      <input name={`ot_item_batch${index}`} value={item.ot_item_batch} onChange={(e) => handleChange1(e, index)} className="form-control" placeholder="Enter Batch" type="text" />
                                    </td>
                                    <td>
                                      <input name={`store_min_qty${index}`} value={item.store_min_qty || ""} onChange={(e) => handleChange1(e, index)} className="form-control" placeholder="Enter Qty" type="number" min={1} />
                                    </td>
                                    <td>
                                      <button className="btn btn-sm btn-danger" onClick={(e) => { e.preventDefault(); setFormData(prev => { const tmp = [...prev.otitems]; tmp.splice(index, 1); return { ...prev, otitems: tmp }; }); }}>Delete</button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Editor toggles and editors */}
                      <div className="col-md-12">
                        <div className="mb-3 d-flex gap-2">
                          <button type="button" className="btn btn-outline-primary" onClick={() => setEditorOpen(prev => ({ ...prev, diagnosis: !prev.diagnosis }))}>Diagnosis {editorOpen.diagnosis ? "▲" : "▼"}</button>
                          <button type="button" className="btn btn-outline-primary" onClick={() => setEditorOpen(prev => ({ ...prev, procedure: !prev.procedure }))}>Procedure {editorOpen.procedure ? "▲" : "▼"}</button>
                          <button type="button" className="btn btn-outline-primary" onClick={() => setEditorOpen(prev => ({ ...prev, course_in_hospital: !prev.course_in_hospital }))}>Course in Hospital {editorOpen.course_in_hospital ? "▲" : "▼"}</button>
                          <button type="button" className="btn btn-outline-primary" onClick={() => setEditorOpen(prev => ({ ...prev, notes: !prev.notes }))}>Notes {editorOpen.notes ? "▲" : "▼"}</button>
                          <button type="button" className="btn btn-success ms-auto" onClick={saveCaseEditorsToServer}>Save Case Content</button>
                        </div>
                        {editorOpen.diagnosis && (
                          <div className="mb-3">
                            <label className="form-label">Diagnosis</label>
                            <CKEditor editor={ClassicEditor} data={caseEditors.diagnosis} onReady={(editor) => { diagEditorRef.current = editor; }} onChange={(event, editor) => { const data = editor.getData(); setCaseEditors(p => ({ ...p, diagnosis: data })); }} />
                          </div>
                        )}

                        {editorOpen.procedure && (
                          <div className="mb-3">
                            <label className="form-label">Procedure</label>
                            <CKEditor editor={ClassicEditor} data={caseEditors.procedure} onReady={(editor) => { procEditorRef.current = editor; }} onChange={(event, editor) => { const data = editor.getData(); setCaseEditors(p => ({ ...p, procedure: data })); }} />
                          </div>
                        )}

                        {editorOpen.course_in_hospital && (
                          <div className="mb-3">
                            <label className="form-label">Course in Hospital</label>
                            <CKEditor editor={ClassicEditor} data={caseEditors.course_in_hospital} onReady={(editor) => { courseEditorRef.current = editor; }} onChange={(event, editor) => { const data = editor.getData(); setCaseEditors(p => ({ ...p, course_in_hospital: data })); }} />
                          </div>
                        )}

                        {editorOpen.notes && (
                          <div className="mb-3">
                            <label className="form-label">Notes</label>
                            <CKEditor editor={ClassicEditor} data={caseEditors.notes} onReady={(editor) => { notesEditorRef.current = editor; }} onChange={(event, editor) => { const data = editor.getData(); setCaseEditors(p => ({ ...p, notes: data })); }} />
                          </div>
                        )}

                      </div>

                      {/* Submit and placeholder print buttons (you said you will handle PDFs later) */}
                    {/* ---------- Button group (replace your current Save/Print block) ---------- */}
<div className="col-lg-12">
  <div className="text-end d-flex gap-2 justify-content-end flex-wrap">
    {/* Save */}
    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
      Save
    </button>

    {/* Print OT Receipt - only after save */}
    <button
      type="button"
      className={`btn ${isSaved ? 'btn-dark' : 'btn-secondary'}`}
      onClick={handlePrintOtReceipt}
      disabled={!isSaved}
      title={!isSaved ? 'Save first to enable printing' : 'Print OT Receipt'}
    >
      Print OT Receipt
    </button>


    <button
  type="button"
  className="btn btn-info"
  onClick={handlePrintOtMedicine}
  disabled={!isSaved || otMedicines.length === 0}
  title={
    !isSaved
      ? "Save OT first"
      : otMedicines.length === 0
      ? "No medicines added"
      : "Print OT Medicine Chart"
  }
>
  Print OT Medicine
</button>


{/* ✅ Hardcoded buttons — ALWAYS visible */}
<button type="button" className="btn btn-warning" onClick={handlePrintConsentForm} title="Print Consent Form">
  Print Consent Form
</button>

<button type="button" className="btn btn-warning" onClick={handlePrintAnesthesiaRecord} title="Print Anaesthesia Record">
  Print Anaesthesia Form
</button>

{/* ✅ Dynamic OT Format buttons — only when they exist */}
{otFormatButtons.length > 0 && otFormatButtons.map(btn => (
  <button
    key={btn.btn_id}
    type="button"
    className="btn btn-sm"
    style={{
      background: btn.btn_color || '#405189',
      color: '#fff',
      border: 'none',
    }}
    onClick={() => handleOtFormatBtnClick(btn)}
    disabled={!isSaved}
    title={!isSaved ? 'Save OT first' : `Print ${btn.btn_name}`}
  >
    {btn.btn_name}
    {(btn.pages || []).length > 0 && (
      <span className="badge bg-light text-dark ms-1" style={{fontSize:9}}>
        {btn.pages.length}pg
      </span>
    )}
  </button>
))}
  
    
    {/* New: Print Doctor List (global list) */}
    <button
      type="button"
      className="btn btn-info"
      onClick={generateDoctorListPdf}
      title="Print / Export Doctor List"
    >
      Print Doctor List
    </button>

    {/* New: Print Vital Chart (patient-specific) */}
    <button
      type="button"
      className="btn btn-info"
      onClick={generateVitalChartPdf}
      disabled={!(formData.ot_uhid_no || formData.ot_uhid)}
      title={formData.ot_uhid_no || formData.ot_uhid ? 'Print Vital Chart' : 'Select a patient (UHID) first'}
    >
      Print Vital Chart
    </button>


    <button
  type="button"
  className="btn btn-secondary"
  onClick={handlePrintDoctorNotes}
  disabled={!isSaved}
  title={!isSaved ? "Save OT first" : "Print Doctor Notes"}
>
  Print Doctor Notes
</button>



    <div className="col-md-4">
  <button
    type="button"
    className="btn btn-danger"
    onClick={() => navigate("/ot_management")}
    
  >
    Close
  </button>
</div>

  </div>
</div>


                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>

          <MedicineModal
  show={showMedicineModal}
  onClose={() => setShowMedicineModal(false)}
  medicineOptions={medicineOptions}
  selectedMedicines={otMedicines}
  loading={medicineLoading}
  onSave={(meds) => {
    setOtMedicines(meds);
    toast.success(`${meds.length} medicine(s) saved`);
  }}
/>

        </div>
      </div>
    </div>
  );
}

export default AddOt;
